import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import { contentContext } from "../../context/contentContext";
import SessionPopup from "../SessionPopup"
import Calendar from 'react-calendar';
import Loader from "../../components/loader";
import 'react-calendar/dist/Calendar.css';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import Tooltip from '@mui/material/Tooltip';
import { ToastContainer, toast } from 'react-toastify';
import SweetAlert from 'react-bootstrap-sweetalert';
import { keyActivate } from "../../utils/a11y";
import tmdbApi from "../../api/tmdbApi";
import { canTakePaidBookings, paidBookingsPaused } from "../stripe/paidBookings";

let { lambda, appname } = window.app

const bookedSlots = {
  '1AM': ['Premium', 'VIP'],
  '3PM': ['Premium', 'VIP'],
  '5PM': ['Free', 'VIP'],
  '8PM': ['Free'],
  '10PM': ['Premium']
};

// Custom Toolbar Component to Hide Today, Back, Next Buttons
const CustomToolbar = () => <div />;

// Custom Header Component to Hide Date Headers
const CustomHeader = () => <div style={{ display: 'none' }} />;

const LayoutWrapper = ({ embedded, children }) => {
  if (embedded) return <>{children}</>;
  return (
    <div id="layout-wrapper">
      <Header />
      <Sidebar />
      {children}
    </div>
  );
};

const PageWrapper = ({ embedded, children }) => {
  if (embedded) return <>{children}</>;
  return (
    <div className="page-content">
      <div className="container-fluid">
        {children}
      </div>
    </div>
  );
};

const SpotsManageCore = ({ storeId, embedded = false, onEditPreferences, autoOpenEditHours = false, onAutoOpenDone }) => {
  const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
  const [toastType, setToastType] = useState("")
  const { userData, setUserData, setActiveMenuId, isLoading, setIsLoading } = useContext(contentContext)
  const [selectedDate, setSelectedDate] = useState(null);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [showSessionPopupup, setShowSessionPopupup] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [image, setImg] = useState(process.env.REACT_APP_IMAGE_CLOUD_FRONT);
  const [showPopup, setShowPoup] = useState(false)
  const autoOpenEditHoursRef = useRef(false);
  const categoryTypesRef = useRef([]);
  const [showSpecialHours, setShowSpecialHours] = useState(false)
  const [dayName, setDayName] = useState('');
  const [showCalender, setShowcalender] = useState(false)
  const [plans, setPlans] = useState([]);
  const [isActive, setIsActive] = useState("regular")
  const [spotDay, setSpotDay] = useState('MONDAY')
  const [selectedDays, setSelectedDays] = useState(["MONDAY"]);
  const [editingPlans, setEditingPlans] = useState({});
  const [singleSplSpot, setSingleSplSpot] = useState([])
  const navigate = useNavigate();
  const [selectedSlots, setSelectedSlots] = useState([]); // Store added slots
  const daysOfWeek = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
  const [plansData, setPlansData] = useState([])
  const [spotsData, setSpotsData] = useState([])
  const [singleSplData, setSingleSplData] = useState({})
  const [SpecialSpotData, setSpecialSpotData] = useState("")
  const [singleSpot, setSingleSpot] = useState({})
  const [singleDayData, setSingleDayData] = useState([])
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [storeList, setStoreList] = useState([]);
  const [formData, setFormData] = useState({
    // businessaddress: '',
    // name: '',
    // category: '',
    // phone: '',
    // logo: [],
    // storeImages: [],
    // idc: "USA(+1)",
    // maxVisitor: 0,
    // maxPartySize: 0,
    // codeExpiration: 0,
    // automatedExit: 0,
    // visitDuration: 0,
    // maxLocationCapacity: 0,
    // basicPlan: {},
    // premiumPlan: {},
    // vipPlan: {}


  });
  const [loaderEnable, setLoaderEnable] = useState(false);
  const [isModal, setIsmodal] = useState(false);


  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  const hours = Array.from({ length: 24 * 4 }, (_, index) => {
    const totalMinutes = index * 15;
    const hour = Math.floor(totalMinutes / 60) % 12 || 12; // Convert 24-hour format to 12-hour
    const minute = (totalMinutes % 60).toString().padStart(2, "0");
    const period = totalMinutes < 720 ? "AM" : "PM";

    return `${hour}:${minute} ${period}`.trim();
  });

  const [selectedDay, setSelectedDay] = useState('MONDAY');
  const [selectedDayNew, setSelectedDayNew] = useState('MONDAY');
  const [timeSlots, setTimeSlots] = useState({
    starttime: '',
    endtime: ''
  });
  const [showModal, setShowModal] = useState(true);
  const [isOpen, setIsOpen] = useState(true);
  // const [isOpen2, setIsOpen2] = useState(true);
  const [selectedOpenTime, setSelectedOpenTime] = useState('');
  const [selectedCloseTime, setSelectedCloseTime] = useState('');
  const [workingHours, setWorkingHours] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [commonLoader, setCommonLoader] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  // Premium & VIP hours states
  const [hourCategories, setHourCategories] = useState([
    { name: 'BASIC HOURS', hours: [] },
    { name: 'PREMIUM HOURS', hours: [] },
    { name: 'VIP HOURS', hours: [] }
  ]);


  const [maxVisitors, setMaxVisitors] = useState(0);
  const [pricePerSpot, setPricePerSpot] = useState(0);
  const [categoryEditMode, setCategoryEditMode] = useState(false);
  const [categoryEditIndex, setCategoryEditIndex] = useState(null);
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);


  // Update handleEditCategoryHours to save the original close time
  const [selectedStartTime, setSelectedStartTime] = useState('');
  const [selectedEndTime, setSelectedEndTime] = useState('');

  const [nextId, setNextId] = useState(1);
  const [categoryTypes, setCategoryTypes] = useState([
    // { name: 'BASIC HOURS', plan: 'Basic', price: 1 },
    // { name: 'PREMIUM HOURS', plan: 'Premium', price: 1000 },
    // { name: 'VIP HOURS', plan: 'VIP', price: 2000 }
  ]);

  // Category management
  // let categoryTypes = [
  //   { name: 'BASIC HOURS', plan: 'Basic', price: 1 },
  //   { name: 'PREMIUM HOURS', plan: 'Premium', price: 1000 },
  //   { name: 'VIP HOURS', plan: 'VIP', price: 2000 }
  // ];

  const [categoryHours, setCategoryHours] = useState([]);
  const [selectedCategoryStartTime, setSelectedCategoryStartTime] = useState('');
  const [selectedCategoryEndTime, setSelectedCategoryEndTime] = useState('');

  // Helper values
  const [endTimeKey, setEndTimeKey] = useState(0);
  const [categoryEndTimeKey, setCategoryEndTimeKey] = useState(0);
  const [originalCloseTime, setOriginalCloseTime] = useState(null);
  const [closeTimeKey, setCloseTimeKey] = useState(0);

  // Add these state variables at the top of your component
  const [showDeleteWorkingHourPopup, setShowDeleteWorkingHourPopup] = useState(false);
  const [showDeleteCategoryHourPopup, setShowDeleteCategoryHourPopup] = useState(false);
  const [deleteWorkingHourId, setDeleteWorkingHourId] = useState(null);
  const [deleteCategoryHourIndex, setDeleteCategoryHourIndex] = useState(null);
  const [isStoreOpen, setIsStoreOpen] = useState(true); // Default to open for new stores
  // Warning modal states
  const [showPlanWarningModal, setShowPlanWarningModal] = useState(false);
  const [missingPlans, setMissingPlans] = useState([]);
  // Updated delete functions
  const [pendingEditIndex, setPendingEditIndex] = useState(null);


  const [isEditingCategory, setIsEditingCategory] = useState(false);
  const [showCategoryDiscardPopup, setShowCategoryDiscardPopup] = useState(false);
  const [pendingCategoryIndex, setPendingCategoryIndex] = useState(null);
  const [pendingClose, setPendingClose] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showCloseConfirmPopup, setShowCloseConfirmPopup] = useState(false);
  const [showDiscardEditConfirm, setShowDiscardEditConfirm] = useState(null); // 'working' | 'category' | null
  const [showDeleteSpecialHourPopup, setShowDeleteSpecialHourPopup] = useState(false);
  const [deleteSpecialHourItem, setDeleteSpecialHourItem] = useState(null);

  // A paid spot can only be collected through the client's own connected account,
  // so while that account can't take paid bookings (no bank yet, or Stripe has
  // paused transfers) those slots can't be booked at all - they stay hidden from
  // customers until it can. null = never looked up, or the lookup failed; only an
  // affirmative false shows the notice, so a failing status call can never nag a
  // client who is already connected.
  const [canTakePaid, setCanTakePaid] = useState(null);
  // Which notice to show when canTakePaid is false: "paused" (Stripe turned transfers
  // off on a connected account) needs different words from "connect your bank".
  const [paidPaused, setPaidPaused] = useState(false);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const response = await tmdbApi.getStripeConnectStatus();
        if (cancelled) return;
        // An expired session is not an answer about the bank account - the list
        // pages have their own sign-in popup for that; leave the status unknown.
        if (tmdbApi.isSessionExpired(response)) return;
        const bankStatus = response?.result || response;
        setCanTakePaid(canTakePaidBookings(bankStatus));
        setPaidPaused(paidBookingsPaused(bankStatus));
      } catch (err) {
        console.error("getStripeConnectStatus error:", err);
      }
    })();

    return () => { cancelled = true; };
  }, []);
  useEffect(() => {
    // When popup opens, pre-fill inputs from the active plan's defaults
    if (showPopup && categoryTypes?.length > 0) {
      const plan = categoryTypes[activeCategoryIndex ?? 0];
      setMaxVisitors(plan?.maxvisitors ?? '');
      setPricePerSpot(plan?.price ?? '');
    }
  }, [showPopup]);

  useEffect(() => {
    // Keep maxVisitors showing the remaining capacity whenever the form is in add mode.
    // Each slot independently allows up to the plan's max visitors (per-slot, not cumulative).
    if (!categoryTypes?.length || categoryEditMode) return;
    const plan = categoryTypes[activeCategoryIndex ?? 0];
    if (!plan) return;
    const planMax = Number(plan.maxvisitors) || 0;
    setMaxVisitors(planMax > 0 ? planMax : '');
    setPricePerSpot(plan.price ?? '');
  }, [categoryTypes, categoryHours, selectedDay, activeCategoryIndex, categoryEditMode]);

  // ====================================================================
  // STEP 3: MODIFY handleAddCategoryHours - Add these lines at the end
  // ====================================================================

  const handleAddCategoryHours = () => {
    if (!selectedCategoryStartTime || !selectedCategoryEndTime) {
      setToastMessage("Please select both start and end times");
      setToastType("error");
      return;
    }

    const categoryPlan = categoryTypes[activeCategoryIndex].plan;
    const startTime = parseTimeString(selectedCategoryStartTime);
    const endTime = parseTimeString(selectedCategoryEndTime);
    const isOvernight = endTime.hour < startTime.hour ||
      (endTime.hour === startTime.hour && endTime.minute < startTime.minute);
    const workingHourId = findWorkingHourIdForTimeRange(selectedCategoryStartTime, selectedCategoryEndTime);

    const newCategoryHour = {
      plan: categoryPlan,
      price: pricePerSpot || categoryTypes[activeCategoryIndex].price,
      active: categoryTypes[activeCategoryIndex].active,
      maxvisitors: Number(maxVisitors),
      starttime: selectedCategoryStartTime,
      endtime: selectedCategoryEndTime,
      day: selectedDay,
      endDay: isOvernight ? getNextDay(selectedDay) : selectedDay,
      id: workingHourId
    };

    let updatedHours = categoryHours.slice();

    if (categoryEditMode) {
      updatedHours = updatedHours.map((hour, index) =>
        index === categoryEditIndex ? newCategoryHour : hour
      );
    } else {
      updatedHours.push(newCategoryHour);
    }

    const planConfig = categoryTypes[activeCategoryIndex];
    const planAllocation = Number(planConfig?.maxvisitors) || 0;
    const newMaxVisitors = Number(maxVisitors) || 0;

    if (newMaxVisitors <= 0) {
      setToastMessage("Max Visitors / Slot must be greater than 0.");
      setToastType("error");
      return;
    }

    if (planAllocation > 0 && newMaxVisitors > planAllocation) {
      setToastMessage(`Max visitors for ${categoryPlan} is ${planAllocation} per slot.`);
      setToastType("error");
      return;
    }

    setCategoryHours(updatedHours);
    setHasUnsavedChanges(true);
    clearCategoryForm(activeCategoryIndex);
    setIsEditingCategory(false);
    setToastMessage(`${categoryPlan} hours ${categoryEditMode ? 'updated' : 'added'} successfully`);
    setToastType("success");
  };


  // ====================================================================
  // STEP 4: MODIFY handleEditCategoryHours - Replace entire function
  // ====================================================================

  const handleEditCategoryHours = (index) => {
    const hourToEdit = categoryHours[index];
    const targetCategoryIndex = categoryTypes.findIndex(cat => cat.plan === hourToEdit.plan);

    // Only warn if the user has actually typed/changed something
    const hasActualChanges = isEditingCategory;

    // If trying to edit a different category while having unsaved changes, show discard popup
    if (hasActualChanges && activeCategoryIndex !== targetCategoryIndex) {
      setPendingCategoryIndex(targetCategoryIndex);
      setPendingEditIndex(index);
      setShowCategoryDiscardPopup(true);
      return;
    }

    // Execute edit
    setActiveCategoryIndex(targetCategoryIndex);
    setCategoryEditMode(true);
    setCategoryEditIndex(index);
    setIsEditingCategory(true);

    // Pre-fill maxvisitors with the current plan allocation (from preferences) if it has changed,
    // rather than the stale DB value — so the user sees the latest recommended allocation.
    const planConfig = targetCategoryIndex >= 0 ? categoryTypes[targetCategoryIndex] : null;
    const suggestedMaxVisitors = planConfig?.maxvisitors ?? hourToEdit.maxvisitors;
    setMaxVisitors(suggestedMaxVisitors);
    setPricePerSpot(hourToEdit.price);
    setSelectedCategoryStartTime(hourToEdit.starttime);

    setTimeout(() => {
      setSelectedCategoryEndTime(hourToEdit.endtime);
    }, 100);
  };



  // ====================================================================
  // STEP 5: ADD NEW FUNCTION - Handle clicking on category header to switch
  // ====================================================================

  const handleCategoryClick = (categoryIndex) => {
    // If already active, do nothing
    if (categoryIndex === activeCategoryIndex) {
      return;
    }

    // Only warn if the user has actually typed/changed something
    const hasActualChanges = isEditingCategory;

    // Only show discard popup if there are actual form values
    if (hasActualChanges) {
      setPendingCategoryIndex(categoryIndex);
      setPendingEditIndex(null);
      setShowCategoryDiscardPopup(true);
      return;
    }

    // Switch to new category and clear form
    setActiveCategoryIndex(categoryIndex);
    clearCategoryForm(categoryIndex);
  };

  const handleCategoryFormClick = (categoryIndex) => {
    // If clicking on a disabled form field of inactive category
    if (categoryIndex !== activeCategoryIndex) {
      // If currently editing another category, show discard popup
      if (isEditingCategory) {
        setPendingCategoryIndex(categoryIndex);
        setPendingEditIndex(null);
        setShowCategoryDiscardPopup(true);
        return;
      }

      // Otherwise just switch
      setActiveCategoryIndex(categoryIndex);
      clearCategoryForm(categoryIndex);
    }
  };


  // ====================================================================
  // STEP 6: ADD NEW FUNCTION - Clear category form
  // ====================================================================

  const clearCategoryForm = (targetIndex = null) => {
    setSelectedCategoryStartTime('');
    setSelectedCategoryEndTime('');
    const plan = categoryTypes[targetIndex ?? activeCategoryIndex];
    setMaxVisitors(plan?.maxvisitors ?? '');
    setPricePerSpot(plan?.price ?? '');
    setCategoryEditMode(false);
    setCategoryEditIndex(null);
    setIsEditingCategory(false);
  };


  // ====================================================================
  // STEP 7: ADD NEW FUNCTION - Handle input changes to track editing
  // ====================================================================

  const handleCategoryInputChange = (setter, value) => {
    setter(value);
    if (value) {
      setIsEditingCategory(true);
    }
  };


  // ====================================================================
  // STEP 8: ADD NEW FUNCTIONS - Handle discard popup
  // ====================================================================

  const handleDiscardAndSwitch = () => {
    if (pendingClose) {
      setPendingClose(false);
      setShowCategoryDiscardPopup(false);
      closeAndReset();
      return;
    }

    clearCategoryForm(pendingCategoryIndex ?? activeCategoryIndex);

    if (pendingCategoryIndex !== null) {
      setActiveCategoryIndex(pendingCategoryIndex);

      // If there was a pending edit, execute it
      if (pendingEditIndex !== null) {
        const hourToEdit = categoryHours[pendingEditIndex];
        const targetPlanConfig = pendingCategoryIndex >= 0 ? categoryTypes[pendingCategoryIndex] : null;
        const suggestedMV = targetPlanConfig?.maxvisitors ?? hourToEdit.maxvisitors;
        setCategoryEditMode(true);
        setCategoryEditIndex(pendingEditIndex);
        setIsEditingCategory(true);
        setMaxVisitors(suggestedMV);
        setPricePerSpot(hourToEdit.price);
        setSelectedCategoryStartTime(hourToEdit.starttime);
        setTimeout(() => {
          setSelectedCategoryEndTime(hourToEdit.endtime);
        }, 100);
      }
    }

    setPendingCategoryIndex(null);
    setPendingEditIndex(null);
    setShowCategoryDiscardPopup(false);
  };

  const handleContinueEditing = () => {
    setPendingClose(false);
    setPendingCategoryIndex(null);
    setPendingEditIndex(null);
    setShowCategoryDiscardPopup(false);
  };

  const handleDeleteWorkingHours = (id) => {
    setDeleteWorkingHourId(id);
    setShowDeleteWorkingHourPopup(true);
  };

  const confirmDeleteWorkingHour = () => {
    // Remove the working hour
    const updatedHours = workingHours.filter(hour => hour.id !== deleteWorkingHourId);
    setWorkingHours(updatedHours);

    // Remove any category hours with this ID
    const updatedCategoryHours = categoryHours.filter(hour => hour.id !== deleteWorkingHourId);
    setCategoryHours(updatedCategoryHours);

    // Reset if in edit mode
    if (editMode && editIndex === deleteWorkingHourId) {
      setEditMode(false);
      setEditIndex(null);
      setSelectedStartTime('');
      setSelectedEndTime('');
    }

    setShowDeleteWorkingHourPopup(false);
    setDeleteWorkingHourId(null);
    setHasUnsavedChanges(true);
  };

  const handleDeleteCategoryHours = (index) => {
    setDeleteCategoryHourIndex(index);
    setShowDeleteCategoryHourPopup(true);
  };

  const confirmDeleteCategoryHour = () => {
    const updatedCategoryHours = categoryHours.filter((_, i) => i !== deleteCategoryHourIndex);
    setCategoryHours(updatedCategoryHours);

    // Reset if in edit mode
    if (categoryEditMode && categoryEditIndex === deleteCategoryHourIndex) {
      setCategoryEditMode(false);
      setCategoryEditIndex(null);
      setSelectedCategoryStartTime('');
      setSelectedCategoryEndTime('');
      setMaxVisitors(0);
      setPricePerSpot(0);
    }

    setShowDeleteCategoryHourPopup(false);
    setDeleteCategoryHourIndex(null);
    setHasUnsavedChanges(true);
  };

  useEffect(() => {
    // Reset close time whenever open time changes
    setSelectedCloseTime('');
    // Increment the key to force re-render of the close time dropdown
    setCloseTimeKey(prevKey => prevKey + 1);
  }, [selectedOpenTime]);
  // Days of the week


  useEffect(() => {
    if (toastMessage && toastType && toast[toastType]) {
      toast[toastType](toastMessage, {
        position: "bottom-center",
        // autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      // Clear the message after showing to prevent re-triggering
      setToastMessage && setToastMessage("");
    }
  }, [toastMessage, toastType]);
  // Reset end time whenever start time changes for working hours
  useEffect(() => {
    setSelectedEndTime('');
    setEndTimeKey(prevKey => prevKey + 1);
  }, [selectedStartTime]);

  // Reset end time whenever start time changes for category hours
  useEffect(() => {
    setSelectedCategoryEndTime('');
    setCategoryEndTimeKey(prevKey => prevKey + 1);
  }, [selectedCategoryStartTime]);

  // Handle editing category hours
  useEffect(() => {
    if (categoryEditMode && categoryEditIndex !== null) {
      const hourToEdit = categoryHours[categoryEditIndex];

      // Set form values
      setMaxVisitors(hourToEdit.maxvisitors);
      setPricePerSpot(hourToEdit.price);
      setSelectedCategoryStartTime(hourToEdit.starttime);

      // Set end time after start time to ensure dependencies resolve properly
      setTimeout(() => {
        setSelectedCategoryEndTime(hourToEdit.endtime);
      }, 50);
    }
  }, [categoryEditMode, categoryEditIndex]);

  useEffect(() => {
    getAllStores();
  }, []);
  // useEffect(() => {
  //   if (id) {
  //     getStore(id);   // <-- auto load clicked store
  //   }
  // }, [id]);
  // Parse time string to extract hour and minute
  const parseTimeString = (timeString) => {
    if (!timeString) return { hour: 0, minute: 0 };
    const [hourStr, minuteStr] = timeString.split(':');
    return {
      hour: parseInt(hourStr, 10),
      minute: parseInt(minuteStr, 10)
    };
  };

  // Get the next day of the week
  const getNextDay = (day) => {
    const index = daysOfWeek.indexOf(day);
    return index < daysOfWeek.length - 1 ? daysOfWeek[index + 1] : daysOfWeek[0];
  };

  // Check if a time is within a given range
  const isTimeWithinRange = (time, rangeStart, rangeEnd) => {
    const timeVal  = time.hour  * 60 + time.minute;
    const startVal = rangeStart.hour * 60 + rangeStart.minute;
    const endVal   = rangeEnd.hour   * 60 + rangeEnd.minute;
    const isOvernightRange = startVal > endVal;

    if (isOvernightRange) {
      // Overnight: in-range if time >= start OR time < end
      return timeVal >= startVal || timeVal < endVal;
    } else {
      // Same-day: in-range if start <= time < end
      return timeVal >= startVal && timeVal < endVal;
    }
  };
  const getAllStores = async () => {
    const token = localStorage.getItem("token");

    const response = await axios({
      method: 'POST',
      url: `${lambda}/getStores?appname=${appname}&clientid=${useruniqueid}&token=${token}`,
    });
    if (response?.data?.result === "Invalid token or Expired") {
      setShowSessionPopupup(true);
      return;
    }

    //  const result = response?.data?.result;
    if (response?.data?.result && Array.isArray(response?.data?.result)) {
      setStoreList(response?.data?.result);
    }
  };

  // Generate 24-hour time slots with 15-minute intervals
  const generateTimeOptions = (day, startHour = 0, startMinute = 0, hoursToGenerate = 24) => {
    const times = [];
    let currentHour = startHour;
    let currentMinute = startMinute;
    const dayAbbr = day?.substring(0, 3);

    for (let i = 0; i < hoursToGenerate * 4; i++) {
      const timeValue = `${String(currentHour).padStart(2, '0')}:${String(currentMinute).padStart(2, '0')}`;

      times.push({
        value: timeValue,
        displayValue: formatTimeForDisplay(timeValue, day),
        hour: currentHour,
        minute: currentMinute,
        day: day
      });

      currentMinute += 15;
      if (currentMinute === 60) {
        currentMinute = 0;
        currentHour++;
      }
    }

    return times;
  };

  // Validate if a new time range would overlap with existing working hours
  const wouldTimeRangeOverlap = (startTime, endTime, excludeId = null) => {
    const start = parseTimeString(startTime);
    const end = parseTimeString(endTime);

    return workingHours.some(slot => {
      if (excludeId === slot.id) return false;

      const slotStart = parseTimeString(slot.starttime);
      const slotEnd = parseTimeString(slot.endtime);

      return (
        (start.hour < slotEnd.hour || (start.hour === slotEnd.hour && start.minute < slotEnd.minute)) &&
        (end.hour > slotStart.hour || (end.hour === slotStart.hour && end.minute > slotStart.minute))
      );
    });
  };

  // Get all start time options for the selected day
  const getStartTimeOptions = () => {
    const dayOptions = generateTimeOptions(selectedDay);

    // Filter out times that would overlap with any existing working hours
    return dayOptions.filter(time => {
      // If in edit mode, don't consider the time slot being edited
      // const relevantWorkingHours = editMode
      //   ? workingHours.filter(hour => hour.id !== editIndex)
      //   : workingHours;

      const relevantWorkingHours = editMode
        ? (workingHours || []).filter(hour => hour.id !== editIndex)
        : (workingHours || []);

      // Check for each working hour slot if the current time would create an overlap
      for (const slot of relevantWorkingHours) {
        const slotStartTime = parseTimeString(slot.starttime);
        const slotEndTime = parseTimeString(slot.endtime);

        // Check if this time is already within an existing slot
        if (isTimeWithinRange(time, slotStartTime, slotEndTime)) {
          return false;
        }
      }

      return true;
    });
  };

  const handleStoreChange = (e) => {
    const selectedStoreId = e?.target?.value;
    if (!selectedStoreId) return;
    getStore(selectedStoreId);
  };


  // Handle editing working hours
  const handleEditWorkingHours = (id) => {
    const hourToEdit = workingHours.find(hour => hour.id === id);
    if (!hourToEdit) return;

    setSelectedStartTime(hourToEdit.starttime);
    setSelectedEndTime(hourToEdit.endtime);
    setEditMode(true);
    setEditIndex(id);
    setHasUnsavedChanges(true);
  };

  // Cancel working hours edit — restore form to empty without closing popup
  const handleCancelWorkingHoursEdit = () => {
    setEditMode(false);
    setEditIndex(null);
    setSelectedStartTime('');
    setSelectedEndTime('');
    setEndTimeKey(k => k + 1);
    // Only clear unsaved flag if no other changes exist
    if (!categoryEditMode && categoryHours.length === 0 && workingHours.length === 0) {
      setHasUnsavedChanges(false);
    }
  };

  // Handle deleting working hours
  const handleDeleteWorkingHoursOld = (id) => {
    // Remove the working hour.
    // console.log("workingHours",workingHours)
    // console.log("id",id)
    const updatedHours = workingHours.filter(hour => hour.id !== id);
    setWorkingHours(updatedHours);

    // Remove any category hours with this ID
    const updatedCategoryHours = categoryHours.filter(hour => hour.id !== id);
    setCategoryHours(updatedCategoryHours);

    // Reset if in edit mode
    if (editMode && editIndex === id) {
      setEditMode(false);
      setEditIndex(null);
      setSelectedStartTime('');
      setSelectedEndTime('');
    }
  };



  // Handle deleting category hours
  const handleDeleteCategoryHoursOld = (index) => {
    const updatedCategoryHours = categoryHours.filter((_, i) => i !== index);
    setCategoryHours(updatedCategoryHours);

    // Reset if in edit mode
    if (categoryEditMode && categoryEditIndex === index) {
      clearCategoryForm(activeCategoryIndex);
    }
  };
  // Add this function to handle Add button click on inactive plans
  const handleInactiveAddClick = (planName) => {
    toast.error(`Please activate the ${planName} plan first to add hours`, {
      position: "top-center",
      autoClose: 3000,
    });
  };


  useEffect(() => {
    //   // console.log("selectedDay:", selectedDay);
  }, [selectedDay]);

  useEffect(() => {
    // // console.log("selectedStartTime:", selectedStartTime);
  }, [selectedStartTime]);

  useEffect(() => {
    // // console.log("selectedEndTime:", selectedEndTime);
  }, [selectedEndTime]);

  useEffect(() => {
    // // console.log("workingHours:", workingHours);
    const maxId = Math.max(0, ...workingHours.map(h => h.id || 0));
    setNextId(maxId + 1);
  }, [workingHours]);

  useEffect(() => {
    // // console.log("editMode:", editMode);
  }, [editMode]);

  useEffect(() => {
    //// console.log("editIndex:", editIndex);
  }, [editIndex]);

  useEffect(() => {
    //  // console.log("nextId:", nextId);
  }, [nextId]);

  useEffect(() => {
    // // console.log("categoryHours:", categoryHours);
  }, [categoryHours]);

  useEffect(() => {
    // // console.log("selectedCategoryStartTime:", selectedCategoryStartTime);
  }, [selectedCategoryStartTime]);

  useEffect(() => {
    // // console.log("selectedCategoryEndTime:", selectedCategoryEndTime);
  }, [selectedCategoryEndTime]);

  useEffect(() => {
    // // console.log("maxVisitors:", maxVisitors);
  }, [maxVisitors]);

  useEffect(() => {
    //// console.log("pricePerSpot:", pricePerSpot);
  }, [pricePerSpot]);

  useEffect(() => {
    //// console.log("categoryEditMode:", categoryEditMode);
  }, [categoryEditMode]);

  useEffect(() => {
    // // console.log("categoryEditIndex:", categoryEditIndex);
  }, [categoryEditIndex]);

  useEffect(() => {
    // // console.log("activeCategoryIndex:", activeCategoryIndex);
  }, [activeCategoryIndex]);


  const formatTimeForDisplay = (timeString, day, isEndTime = false, startTimeDay = null) => {
    if (!timeString) return '';

    const [hourStr, minuteStr] = timeString.split(':');
    const hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);

    const hour12 = hour % 12 === 0 ? 12 : hour % 12;
    const amPm = hour < 12 ? 'AM' : 'PM';
    const formattedHour = String(hour12).padStart(2, '0');
    const formattedMinute = String(minute).padStart(2, '0');

    // Determine which day to display for end times
    let displayDay = day;
    if (isEndTime && startTimeDay) {
      // If this is an end time and we have a start time to compare with
      const startDay = startTimeDay;
      const startHour = parseTimeString(startTimeDay.time).hour;

      // If end time is earlier in the day than start time, it's likely the next day
      if (hour < startHour || (hour === startHour && minute < parseTimeString(startTimeDay.time).minute)) {
        displayDay = getNextDay(startDay.day);
      }
    }

    const dayAbbr = displayDay?.substring(0, 3);
    return `${formattedHour}:${formattedMinute} ${amPm} (${dayAbbr})`;
  };

  useEffect(() => {
    if (editMode && editIndex !== null) {
      const hourToEdit = workingHours.find(hour => hour.id === editIndex);
      if (hourToEdit) {
        // First set the start time
        setSelectedStartTime(hourToEdit.starttime);

        // Then set the end time directly, bypassing the reset effect
        setSelectedEndTime(hourToEdit.endtime);
      }
    }
  }, [editMode, editIndex, workingHours]);


  useEffect(() => {
    // Only reset end time when start time changes and NOT in edit mode
    if (!editMode) {
      setSelectedEndTime('');
      setEndTimeKey(prevKey => prevKey + 1);
    }
  }, [selectedStartTime, editMode]);

  // 4. Modify the getEndTimeOptions function to properly handle next day times
  const getEndTimeOptions = () => {
    if (!selectedStartTime) return [];

    const selectedStart = parseTimeString(selectedStartTime);
    const dayOptions = generateTimeOptions(selectedDay);
    const nextDayOptions = generateTimeOptions(getNextDay(selectedDay));

    // Add day information to each option
    const dayOptionsWithDay = dayOptions.map(option => ({
      ...option,
      actualDay: selectedDay
    }));

    const nextDayOptionsWithDay = nextDayOptions.map(option => ({
      ...option,
      actualDay: getNextDay(selectedDay)
    }));

    // Combine current day and next day options
    const allOptions = [...dayOptionsWithDay, ...nextDayOptionsWithDay];

    // Find the index of the selected start time
    const selectedStartIndex = allOptions.findIndex(
      time => time.hour === selectedStart.hour && time.minute === selectedStart.minute && time.actualDay === selectedDay
    );

    if (selectedStartIndex === -1) return [];

    // Get all potential end times (times after the selected start time)
    const potentialEndTimes = allOptions.slice(selectedStartIndex + 1);

    // Filter out times that would overlap with existing working hours
    return potentialEndTimes.filter(endTime => {
      // If in edit mode, don't consider the time slot being edited
      const relevantWorkingHours = editMode
        ? workingHours.filter(hour => hour.id !== editIndex)
        : workingHours;

      // Check for overlap with each existing working hour slot
      for (const slot of relevantWorkingHours) {
        const slotStartTime = parseTimeString(slot.starttime);
        const slotEndTime = parseTimeString(slot.endtime);

        // Handle case where slot end time might be in next day (earlier hours)
        const slotIsOvernight = slotEndTime.hour < slotStartTime.hour ||
          (slotEndTime.hour === slotStartTime.hour && slotEndTime.minute < slotStartTime.minute);

        // Check if this potential end time would overlap with existing slots
        const isCurrentDayEnd = endTime.actualDay === selectedDay;
        const isNextDayEnd = endTime.actualDay === getNextDay(selectedDay);

        // Case 1: Selected start time is before slot's start time
        if (selectedStart.hour < slotStartTime.hour ||
          (selectedStart.hour === slotStartTime.hour && selectedStart.minute < slotStartTime.minute)) {

          // End time must be before or equal to the slot's start time
          if (isCurrentDayEnd && (endTime.hour > slotStartTime.hour ||
            (endTime.hour === slotStartTime.hour && endTime.minute > slotStartTime.minute))) {
            return false;
          }
        }

        // Case 2: Selected start time is within or after the slot
        else if (slotIsOvernight) {
          // For overnight slots, compare with care
          if (isCurrentDayEnd && (slotStartTime.hour <= endTime.hour)) {
            return false;
          }
        } else if (selectedStart.hour < slotEndTime.hour ||
          (selectedStart.hour === slotEndTime.hour && selectedStart.minute < slotEndTime.minute)) {
          // Start time is within the slot, which shouldn't be possible due to getStartTimeOptions filtering
          return false;
        }
      }

      return true;
    });
  };
  // console.log('category types', categoryTypes)
  // // console.log('maxvisitors', maxVisitors)
  // // console.log('pricePerSpot', pricePerSpot)
  // 5. Modify the handleAddWorkingHours function to store day information correctly
  const handleAddWorkingHours = () => {
    if (!selectedStartTime || !selectedEndTime) {
      setToastMessage("Please select both start and end times");
      setToastType("error");
      return;
    }

    if (wouldTimeRangeOverlap(selectedStartTime, selectedEndTime, editMode ? editIndex : null)) {
      alert("This time range would overlap with existing working hours. Please select a different range.");
      return;
    }

    const startTime = parseTimeString(selectedStartTime);
    const endTime = parseTimeString(selectedEndTime);
    const isOvernight = endTime.hour < startTime.hour ||
      (endTime.hour === startTime.hour && endTime.minute < startTime.minute);

    const hourId = editMode ? editIndex : nextId;

    const newWorkingHour = {
      id: hourId,
      starttime: selectedStartTime,
      endtime: selectedEndTime,
      day: selectedDay,
      endDay: isOvernight ? getNextDay(selectedDay) : selectedDay,
      // startendid: generateUniqueId() // optional, if you want a Mongo-style UID
    };

    let updatedWorkingHours;

    if (editMode) {
      updatedWorkingHours = workingHours.map(hour =>
        hour.id === editIndex ? newWorkingHour : hour
      );

      const updatedCategoryHours = categoryHours.map(hour => {
        if (hour.id === editIndex) {
          return {
            ...hour,
            starttime: selectedStartTime,
            endtime: selectedEndTime,
            day: selectedDay,
            endDay: newWorkingHour.endDay
          };
        }
        return hour;
      });
      // console.log("updatedCategoryHours",updatedCategoryHours)
      setCategoryHours(updatedCategoryHours);
      setEditMode(false);
      setEditIndex(null);
    } else {
      updatedWorkingHours = [...workingHours, newWorkingHour];

      // Each working hour slot gets the full per-slot plan allocation (non-cumulative).
      const newCategoryHours = categoryTypes.map(category => {
        const planMax = Number(category.maxvisitors) || 0;
        return {
          plan: category.plan,
          price: category.price,
          maxvisitors: planMax,
          starttime: selectedStartTime,
          endtime: selectedEndTime,
          day: selectedDay,
          endDay: newWorkingHour.endDay,
          id: hourId,
          active: category.active,
          workingHourId: hourId,
        };
      });

      setCategoryHours(prev => [...prev, ...newCategoryHours]);
      setNextId(prev => prev + 1); // Increment only after adding
    }

    setWorkingHours(updatedWorkingHours);
    setHasUnsavedChanges(true);
    setSelectedStartTime('');
    setSelectedEndTime('');
  };

  // const generateUniqueId = () => {
  //   return Math.random().toString(16).slice(2) + Date.now().toString(16);
  // };

  useEffect(() => {
    if (categoryEditMode && categoryEditIndex !== null) {
      const hourToEdit = categoryHours[categoryEditIndex];

      // Set all form values at once
      setMaxVisitors(hourToEdit.maxvisitors);
      setPricePerSpot(hourToEdit.price);
      setSelectedCategoryStartTime(hourToEdit.starttime);
      setSelectedCategoryEndTime(hourToEdit.endtime);
    }
  }, [categoryEditMode, categoryEditIndex]);

  // 3. Change the useEffect that resets category end time to respect edit mode
  // Replace the current useEffect with this:
  useEffect(() => {
    // Only reset end time when start time changes and NOT in category edit mode
    if (!categoryEditMode) {
      setSelectedCategoryEndTime('');
      setCategoryEndTimeKey(prevKey => prevKey + 1);
    }
  }, [selectedCategoryStartTime, categoryEditMode]);

  // 4. Update the getCategoryEndTimeOptions function to handle overnight times
  const getCategoryEndTimeOptions = () => {
    if (!selectedCategoryStartTime) return [];

    // Find the working hour that contains this start time
    const workingHour = workingHours.find(hour => {
      const startTime = parseTimeString(hour.starttime);
      const endTime = parseTimeString(hour.endtime);
      const selectedTime = parseTimeString(selectedCategoryStartTime);

      return isTimeWithinRange(selectedTime, startTime, endTime) ||
        (startTime.hour === selectedTime.hour && startTime.minute === selectedTime.minute);
    });

    if (!workingHour) return [];

    // Generate all time slots from the selected start time to the end of the working hour
    const startTime = parseTimeString(selectedCategoryStartTime);
    const endTime = parseTimeString(workingHour.endtime);
    const workingHourStart = parseTimeString(workingHour.starttime);

    // Determine if the working hour extends to the next day
    const isOvernight = endTime.hour * 60 + endTime.minute <
      workingHourStart.hour * 60 + workingHourStart.minute;

    // Determine if the selected start time is already in the "next day" portion of the overnight slot
    // (e.g., selecting 1:00 AM when working hours span 12 PM to 2 AM)
    const startTimeVal = startTime.hour * 60 + startTime.minute;
    const whStartVal   = workingHourStart.hour * 60 + workingHourStart.minute;
    const isStartOnNextDay = isOvernight && startTimeVal < whStartVal;

    const endTimeOptions = [];
    let currentHour = startTime.hour;
    let currentMinute = startTime.minute;

    // Add 15 minutes to start with the next slot
    currentMinute += 15;
    if (currentMinute === 60) {
      currentMinute = 0;
      currentHour++;
      if (currentHour === 24) currentHour = 0;
    }

    if (isStartOnNextDay) {
      // Start time is already past midnight — just generate up to the working hour end time
      while (
        currentHour < endTime.hour ||
        (currentHour === endTime.hour && currentMinute <= endTime.minute)
      ) {
        const timeValue = `${String(currentHour).padStart(2, '0')}:${String(currentMinute).padStart(2, '0')}`;

        endTimeOptions.push({
          value: timeValue,
          displayValue: formatTimeForDisplay(timeValue, getNextDay(selectedDay)),
          hour: currentHour,
          minute: currentMinute,
          day: getNextDay(selectedDay),
          actualDay: getNextDay(selectedDay)
        });

        currentMinute += 15;
        if (currentMinute === 60) {
          currentMinute = 0;
          currentHour++;
        }
      }
    } else {
      const maxHour = isOvernight ? 23 : endTime.hour;
      const maxMinute = isOvernight ? 45 : endTime.minute;

      // Generate all slots until the end of the working hour for current day
      while (
        currentHour < maxHour ||
        (currentHour === maxHour && currentMinute <= maxMinute)
      ) {
        const timeValue = `${String(currentHour).padStart(2, '0')}:${String(currentMinute).padStart(2, '0')}`;

        endTimeOptions.push({
          value: timeValue,
          displayValue: formatTimeForDisplay(timeValue, selectedDay),
          hour: currentHour,
          minute: currentMinute,
          day: selectedDay,
          actualDay: selectedDay
        });

        currentMinute += 15;
        if (currentMinute === 60) {
          currentMinute = 0;
          currentHour++;
        }
      }

      // If overnight, add the next day options (00:00 to endTime)
      if (isOvernight) {
        currentHour = 0;
        currentMinute = 0;

        while (
          currentHour < endTime.hour ||
          (currentHour === endTime.hour && currentMinute <= endTime.minute)
        ) {
          const timeValue = `${String(currentHour).padStart(2, '0')}:${String(currentMinute).padStart(2, '0')}`;

          endTimeOptions.push({
            value: timeValue,
            displayValue: formatTimeForDisplay(timeValue, getNextDay(selectedDay)),
            hour: currentHour,
            minute: currentMinute,
            day: getNextDay(selectedDay),
            actualDay: getNextDay(selectedDay)
          });

          currentMinute += 15;
          if (currentMinute === 60) {
            currentMinute = 0;
            currentHour++;
          }
        }
      }
    }

    // If in edit mode, make sure the current end time is included
    if (categoryEditMode && categoryEditIndex !== null) {
      const editingHour = categoryHours[categoryEditIndex];
      const endTimeExists = endTimeOptions.some(opt => opt.value === editingHour.endtime);

      if (!endTimeExists && editingHour.starttime === selectedCategoryStartTime) {
        const { hour, minute } = parseTimeString(editingHour.endtime);
        const timeValue = editingHour.endtime;

        // Determine the day for this end time
        const isEditedHourOvernight = hour < startTime.hour ||
          (hour === startTime.hour && minute < startTime.minute);
        const endTimeDay = isEditedHourOvernight ? getNextDay(selectedDay) : selectedDay;

        endTimeOptions.push({
          value: timeValue,
          displayValue: formatTimeForDisplay(timeValue, endTimeDay),
          hour: hour,
          minute: minute,
          day: endTimeDay,
          actualDay: endTimeDay
        });

        // Sort by time
        endTimeOptions.sort((a, b) => {
          if (a.actualDay !== b.actualDay) {
            // Different days - next day comes after current day
            return a.actualDay === selectedDay ? -1 : 1;
          }
          if (a.hour !== b.hour) return a.hour - b.hour;
          return a.minute - b.minute;
        });
      }
    }

    return endTimeOptions;
  };



  const handleAddCategoryHours2 = () => {
    if (!selectedCategoryStartTime || !selectedCategoryEndTime) {
      setToastMessage("Please select both start and end times");
      setToastType("error");
      return;
    }

    const categoryPlan = categoryTypes[activeCategoryIndex].plan;
    const startTime = parseTimeString(selectedCategoryStartTime);
    const endTime = parseTimeString(selectedCategoryEndTime);
    const isOvernight = endTime.hour < startTime.hour ||
      (endTime.hour === startTime.hour && endTime.minute < startTime.minute);
    const workingHourId = findWorkingHourIdForTimeRange(selectedCategoryStartTime, selectedCategoryEndTime);

    const newCategoryHour = {
      plan: categoryPlan,
      price: pricePerSpot || categoryTypes[activeCategoryIndex].price,
      active: categoryTypes[activeCategoryIndex].active,
      maxvisitors: Number(maxVisitors),
      starttime: selectedCategoryStartTime,
      endtime: selectedCategoryEndTime,
      day: selectedDay,
      endDay: isOvernight ? getNextDay(selectedDay) : selectedDay,
      id: workingHourId
    };

    let updatedHours = categoryHours.slice();

    if (categoryEditMode) {
      updatedHours = updatedHours.map((hour, index) =>
        index === categoryEditIndex ? newCategoryHour : hour
      );
    } else {
      updatedHours.push(newCategoryHour);
    }

    const planConfig2 = categoryTypes[activeCategoryIndex];
    const planAllocation2 = Number(planConfig2?.maxvisitors) || 0;
    const newMV2 = Number(maxVisitors) || 0;

    if (newMV2 <= 0) {
      setToastMessage("Max Visitors / Slot must be greater than 0.");
      setToastType("error");
      return;
    }

    if (planAllocation2 > 0 && newMV2 > planAllocation2) {
      setToastMessage(`Max visitors for ${categoryPlan} is ${planAllocation2} per slot.`);
      setToastType("error");
      return;
    }

    setCategoryHours(updatedHours);
    clearCategoryForm(activeCategoryIndex);
  };


  console.log('singleSpot', singleSpot)
  console.log('singleSplSpot', singleSplSpot)
  console.log('singleSplData', singleSplData)
  console.log('singleSpot', singleSpot)
  console.log('singleSplSpot', singleSplSpot)
  console.log('singleSplData', singleSplData)

  // 7. Update the findWorkingHourIdForTimeRange function to better handle time ranges
  const findWorkingHourIdForTimeRange = (startTime, endTime) => {
    const start = parseTimeString(startTime);
    const end = parseTimeString(endTime);

    // Check if this is an overnight timespan
    const isOvernight = end.hour < start.hour ||
      (end.hour === start.hour && end.minute < start.minute);

    const hour = workingHours.find(h => {
      const hStart = parseTimeString(h.starttime);
      const hEnd = parseTimeString(h.endtime);

      // Check if the working hour is also overnight
      const hIsOvernight = hEnd.hour < hStart.hour ||
        (hEnd.hour === hStart.hour && hEnd.minute < hStart.minute);

      // For simple same-day comparisons
      if (!isOvernight && !hIsOvernight) {
        return hStart.hour <= start.hour && hEnd.hour >= end.hour &&
          start.hour <= end.hour;
      }

      // For overnight comparisons
      if (isOvernight && hIsOvernight) {
        // Both ranges are overnight, check containment
        return hStart.hour <= start.hour &&
          ((hEnd.hour > end.hour) || (hEnd.hour === end.hour && hEnd.minute >= end.minute));
      }

      // Mixed cases (one overnight, one not) - handle with specific logic
      return h.starttime <= startTime &&
        ((hIsOvernight && end.hour <= 23) || (!hIsOvernight && h.endtime >= endTime));
    });

    return hour ? hour.id : null;
  };

  // // console.log('Updated Selected Days:3333333333333333333333333', selectedDays)


  // Modify the getCategoryStartTimeOptions function to properly handle overnight editing
  const getCategoryStartTimeOptions = () => {
    // Special case for edit mode - if we're editing, we need to ensure the current start time is available
    if (categoryEditMode && categoryEditIndex !== null) {
      const hourToEdit = categoryHours[categoryEditIndex];
      const categoryPlan = categoryTypes[activeCategoryIndex].plan;

      // If we're editing a record in the currently active category
      if (hourToEdit?.plan === categoryPlan) {
        // Find the corresponding working hour
        const correspondingWorkingHour = workingHours.find(hour => hour.id === hourToEdit.id);

        if (correspondingWorkingHour) {
          // Generate all available time slots from the working hour
          const startTime = parseTimeString(correspondingWorkingHour.starttime);
          const endTime = parseTimeString(correspondingWorkingHour.endtime);

          const availableSlots = [];
          let currentHour = startTime.hour;
          let currentMinute = startTime.minute;

          // Include the hour being edited regardless of conflicts
          const editingStartTime = hourToEdit.starttime;

          // Generate all time slots from working hour
          const isOvernightWH = endTime.hour < startTime.hour ||
            (endTime.hour === startTime.hour && endTime.minute <= startTime.minute);
          let passedMidnightEdit = false;

          while (true) {
            // Stop at the working hour's end time (properly handling overnight)
            if (isOvernightWH) {
              if (passedMidnightEdit && (
                currentHour > endTime.hour ||
                (currentHour === endTime.hour && currentMinute >= endTime.minute)
              )) break;
            } else {
              if (
                currentHour > endTime.hour ||
                (currentHour === endTime.hour && currentMinute >= endTime.minute)
              ) break;
            }

            const timeValue = `${String(currentHour).padStart(2, '0')}:${String(currentMinute).padStart(2, '0')}`;

            // Only add slots that don't conflict with other category hours of the same plan
            // or if it's the slot we're currently editing
            const isCurrentlyEditedTime = timeValue === editingStartTime;

            const isTimeUsed = categoryHours.some((hour, index) => {
              // Skip the hour being edited
              if (index === categoryEditIndex) {
                return false;
              }

              // Only check hours with the same plan
              if (hour.plan !== categoryPlan) {
                return false;
              }

              // Check if this time slot is already used
              const hourStart = parseTimeString(hour.starttime);
              const hourEnd = parseTimeString(hour.endtime);

              // Handle overnight scenarios
              const isHourOvernight = hourEnd.hour < hourStart.hour ||
                (hourEnd.hour === hourStart.hour && hourEnd.minute < hourStart.minute);

              if (hour.starttime === timeValue) {
                return true;
              }

              if (isHourOvernight) {
                // For overnight hours, check if time is between start and midnight or between midnight and end
                if (
                  (currentHour >= hourStart.hour && currentHour <= 23) ||
                  (currentHour >= 0 && currentHour < hourEnd.hour) ||
                  (currentHour === hourEnd.hour && currentMinute < hourEnd.minute)
                ) {
                  return true;
                }
              } else {
                // For same-day hours, simple range check
                if (
                  (currentHour > hourStart.hour || (currentHour === hourStart.hour && currentMinute >= hourStart.minute)) &&
                  (currentHour < hourEnd.hour || (currentHour === hourEnd.hour && currentMinute < hourEnd.minute))
                ) {
                  return true;
                }
              }

              return false;
            });

            if (isCurrentlyEditedTime || !isTimeUsed) {
              availableSlots.push({
                value: timeValue,
                displayValue: formatTimeForDisplay(timeValue, selectedDay),
                hour: currentHour,
                minute: currentMinute,
                day: selectedDay
              });
            }

            currentMinute += 15;
            if (currentMinute === 60) {
              currentMinute = 0;
              currentHour++;
              if (currentHour === 24) {
                currentHour = 0;
                passedMidnightEdit = true;
              }
            }
          }

          // Special case: ensure the editing start time is included
          const editingStartExists = availableSlots.some(slot => slot.value === editingStartTime);

          if (!editingStartExists) {
            const { hour, minute } = parseTimeString(editingStartTime);
            availableSlots.push({
              value: editingStartTime,
              displayValue: formatTimeForDisplay(editingStartTime, selectedDay),
              hour: hour,
              minute: minute,
              day: selectedDay
            });
          }

          // Sort by time
          availableSlots.sort((a, b) => {
            if (a.hour !== b.hour) return a.hour - b.hour;
            return a.minute - b.minute;
          });

          return availableSlots;
        }
      }
    }

    // Regular (non-edit) logic for getting available category start times
    // Get all time slots from working hours
    const availableSlots = [];

    workingHours?.forEach(slot => {
      const startTime = parseTimeString(slot.starttime);
      const endTime = parseTimeString(slot.endtime);
      let currentHour = startTime.hour;
      let currentMinute = startTime.minute;

      const isOvernightSlot = endTime.hour < startTime.hour ||
        (endTime.hour === startTime.hour && endTime.minute <= startTime.minute);
      let passedMidnight = false;

      // Generate all 15-minute slots between start and end times
      while (true) {
        // Stop at the working hour's end time (properly handling overnight)
        if (isOvernightSlot) {
          if (passedMidnight && (
            currentHour > endTime.hour ||
            (currentHour === endTime.hour && currentMinute >= endTime.minute)
          )) break;
        } else {
          if (
            currentHour > endTime.hour ||
            (currentHour === endTime.hour && currentMinute >= endTime.minute)
          ) break;
        }

        const timeValue = `${String(currentHour).padStart(2, '0')}:${String(currentMinute).padStart(2, '0')}`;

        availableSlots.push({
          value: timeValue,
          displayValue: formatTimeForDisplay(timeValue, selectedDay),
          hour: currentHour,
          minute: currentMinute,
          day: selectedDay
        });

        currentMinute += 15;
        if (currentMinute === 60) {
          currentMinute = 0;
          currentHour++;
          if (currentHour === 24) {
            currentHour = 0;
            passedMidnight = true;
          }
        }
      }
    });

    // Filter out times that are already used in this category
    return availableSlots.filter(timeSlot => {
      // Filter based on the active category
      const categoryPlan = categoryTypes[activeCategoryIndex].plan;

      // Check if this time is already used in this category
      const isTimeUsed = categoryHours.some((hour, index) => {
        // Skip the hour being edited
        if (categoryEditMode && index === categoryEditIndex) {
          return false;
        }

        // Only check hours with the same plan
        if (hour.plan !== categoryPlan) {
          return false;
        }

        // Check if this time slot is the start time of another hour
        if (hour.starttime === timeSlot.value) {
          return true;
        }

        // Check if this time slot falls within another hour's range
        const hourStart = parseTimeString(hour.starttime);
        const hourEnd = parseTimeString(hour.endtime);

        // Handle overnight ranges
        const isOvernight = hourEnd.hour < hourStart.hour ||
          (hourEnd.hour === hourStart.hour && hourEnd.minute < hourStart.minute);

        if (isOvernight) {
          // For overnight ranges, check if the time is between start and midnight
          // or between midnight and end time
          return (timeSlot.hour >= hourStart.hour && timeSlot.hour <= 23) ||
            (timeSlot.hour >= 0 && timeSlot.hour < hourEnd.hour) ||
            (timeSlot.hour === hourEnd.hour && timeSlot.minute < hourEnd.minute);
        } else {
          // For same-day ranges, simple check
          return isTimeWithinRange(timeSlot, hourStart, hourEnd);
        }
      });

      return !isTimeUsed;
    });
  };


  // Modify handleEditCategoryHours to properly set up for editing overnight records
  const handleEditCategoryHours2 = (index) => {
    const hourToEdit = categoryHours[index];

    // First, set the active category
    setActiveCategoryIndex(categoryTypes.findIndex(cat => cat.plan === hourToEdit.plan));

    // Set editing mode
    setCategoryEditMode(true);
    setCategoryEditIndex(index);

    // Set form values in one go to avoid race conditions
    setMaxVisitors(hourToEdit.maxvisitors);
    setPricePerSpot(hourToEdit.price);

    // Need to set these in the correct order with a small delay to ensure the dropdown populates correctly
    setSelectedCategoryStartTime(hourToEdit.starttime);

    // Using setTimeout to ensure the start time is processed before setting end time
    setTimeout(() => {
      setSelectedCategoryEndTime(hourToEdit.endtime);
    }, 100);
  };

  // Update the useEffect that handles category editing to properly initialize form values
  useEffect(() => {
    if (categoryEditMode && categoryEditIndex !== null) {
      const hourToEdit = categoryHours[categoryEditIndex];

      // Set all form values
      setMaxVisitors(hourToEdit.maxvisitors);
      setPricePerSpot(hourToEdit.price);

      // Make sure we're setting values in correct order with delays to allow dependencies to update
      setSelectedCategoryStartTime(hourToEdit.starttime);

      // Need a delay before setting end time so that the dropdown can populate based on start time
      setTimeout(() => {
        setSelectedCategoryEndTime(hourToEdit.endtime);
      }, 100);
    }
  }, [categoryEditMode, categoryEditIndex]);

  // Modify the useEffect that resets the end time when the start time changes
  // to account for edit mode properly
  useEffect(() => {
    // Only reset end time when not in edit mode or when the user manually changes the start time
    if (categoryEditMode) {
      // In edit mode, don't reset end time automatically
      // This prevents the selected end time from being cleared during edit initialization
      return;
    }

    // For non-edit mode or manual changes, reset the end time
    setSelectedCategoryEndTime('');
    setCategoryEndTimeKey(prevKey => prevKey + 1);
  }, [selectedCategoryStartTime]);







  useEffect(() => {
    if (singleSpot !== null) {
      // // console.log("State updated:", singleSpot);
    }
  }, [singleSpot]);



  const handleOpenTimeChange = (e) => {
    setTimeSlots({
      ...timeSlots,
      starttime: e.target.value,

    });

  };
  useEffect(() => {

    //setActiveMenuId(200002)

  }, []);


  // const disablePastDates = ({ date }) => {
  //   const today = new Date();
  //   // Remove time portion for accurate comparison
  //   today.setHours(0, 0, 0, 0);
  //   return date < today;
  // };


  const disablePastDates = ({ date }) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // If singleSplHour and its date exist
    if (singleSplData?.spotspecialfromdate) {
      const specialDate = new Date(singleSplData.spotspecialfromdate);
      specialDate.setHours(0, 0, 0, 0);
      date.setHours(0, 0, 0, 0);

      // Enable only the date that matches the special date
      return date.getTime() !== specialDate.getTime();
    }

    // Default behavior: disable past dates
    return date < today;
  };


  // Disable past dates based on dataArray length condition
  // const disablePastDates = ({ date }) => {
  //   const today = new Date();
  //   // Remove time portion for accurate comparison
  //   today.setHours(0, 0, 0, 0);

  //   // Disable past dates only if the dataArray length is greater than 0
  //   if (workingHours.length > 0) {
  //     return date < today; // Disable past dates if condition is true
  //   }
  //   return false; // If the condition is false, don't disable any dates
  // };
  const handleDateChange = (date) => {
    // setSelectedDate(date);


    // Format to MM-DD-YYYY
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();

    const formatted = `${mm}-${dd}-${yyyy}`;
    setSelectedDate(formatted);
    // // console.log('Selected date:', formatted);
    let day = date.toLocaleDateString('en-US', { weekday: 'long' });
    // // console.log('dayyyyyyyyyyyyyyyyyy', day)

    const formattedDay = day.trim().toUpperCase();
    setSelectedDay(formattedDay)
    setDayName(formattedDay);
    // // console.log("dayNameeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", formattedDay)
    // You can also format or store it in a global state here
  };
  // // console.log('selected date', selectedDate)
  const userActivity = () => {
    let path = window.location.pathname.split("/");
    const pageName = path[path.length - 1];
    let presentTime = moment();
    let payload;

    payload = {
      "clientid": localStorage.getItem("clientid"),
      "pagename": pageName,
      "pageurl": window.location.href,
      "starttime": presentTime,
      "useragent": JSON.parse(localStorage.getItem("loc"))

    };


    const previousId = localStorage.getItem("previousid");
    const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


    axios({
      method: 'POST',
      url: urlLink,
      data: payload
    })
      .then(function (response) {
        if (response?.data?.statusCode === 200) {
          localStorage.setItem("previousid", response?.data?.result)
        }
      });
  }
  // // console.log('activeCategoryIndex', activeCategoryIndex)

  const isDisabled = (time) => {
    if (!selectedSlots || selectedSlots.length === 0) return false; // No restrictions if no slots are selected

    const currentIndex = hours.indexOf(time);
    if (currentIndex === -1) return false; // If time is not found, return false

    const editStartIndex = hours.indexOf(timeSlots?.starttime);

    const cleanEndTime = timeSlots?.endtime
      ? timeSlots.endtime.replace(/\s*\(\w+\)\s*/, '').trim()
      : '';


    let editEndIndex = hours.indexOf(cleanEndTime);

    const spansNextDay = editEndIndex < editStartIndex;
    if (spansNextDay) {
      editEndIndex += hours.length; // Extend end index to include next day's hours
    }

    if (editStartIndex !== -1 && editEndIndex !== -1) {

      if (currentIndex >= editStartIndex && currentIndex <= editEndIndex) {

        return false; // Enable times within the editing range
      }
    }

    // Extract all selected start and end indexes, handling multi-day spans
    const selectedRanges = selectedSlots.map(slot => {

      const cleanEndTime = slot.endtime.replace(/\s*\(\w+\)\s*/, '').trim(); // Remove (Monday) etc.

      const startIdx = hours.indexOf(slot.starttime);
      let endIdx = hours.indexOf(cleanEndTime);


      if (startIdx === -1 || endIdx === -1) return null; // Skip invalid slots

      // Check if end time is before start time (spans to the next day)
      const spansNextDay = endIdx <= startIdx;

      if (spansNextDay) {
        endIdx += hours.length; // Adjust for next-day wrap-around
      }

      return { start: startIdx, end: endIdx, spansNextDay };
    }).filter(slot => slot !== null);



    // Check if the selected time falls within any existing slot range
    return selectedRanges.some(({ start, end, spansNextDay }) =>
      (currentIndex >= start && currentIndex <= end) ||  // Normal case (same day)
      // (spansNextDay && (currentIndex + hours.length >= start && currentIndex + hours.length <= end)) || // Next day wrap-around case
      (spansNextDay && currentIndex >= start) // Ensure end of Monday is also disabled
    );
  };



  const getValidPlanHours = (planName) => {
    const validSlots = [];

    // Retrieve the plan from editingPlans if we are editing
    const editingPlan = editingPlans[planName];
    const isEditingThisPlan = editingPlan !== undefined;

    // Pre-calculate start/end indices if we are editing
    const editingStart = editingPlan?.starttime?.replace(/\s*\(\w+\)\s*/, '').trim();
    const editingEnd = editingPlan?.endtime?.replace(/\s*\(\w+\)\s*/, '').trim();
    const editingStartIdx = hours.indexOf(editingStart);
    const editingEndIdx = hours.indexOf(editingEnd);

    plans.forEach(plan => {
      if (!plan.starttime || !plan.endtime) return;

      const endLabelMatch = plan.endtime.match(/\((\w+)\)/);
      const startDay = selectedDay;
      const endDay = endLabelMatch ? endLabelMatch[1] : '';

      const rawStart = plan.starttime.replace(/\s*\(\w+\)\s*/, '').trim();
      const rawEnd = plan.endtime.replace(/\s*\(\w+\)\s*/, '').trim();

      const startIdx = hours.indexOf(rawStart);
      const endIdx = hours.indexOf(rawEnd);
      if (startIdx === -1 || endIdx === -1) return;

      // Decide if a given hour index i should be enabled
      const shouldEnable = (i) => {
        if (!isEditingThisPlan) return false; // Only if editing
        if (editingStartIdx === -1 || editingEndIdx === -1) return false; // If editing plan times are invalid
        if (editingStartIdx <= editingEndIdx) {
          // same-day range
          return i >= editingStartIdx && i <= editingEndIdx;
        } else {
          // cross-day range
          return i >= editingStartIdx || i <= editingEndIdx;
        }
      };

      // Generate the slots for this plan
      if (endIdx <= startIdx) {
        // Cross-day plan
        for (let i = startIdx; i < hours.length; i++) {
          validSlots.push({
            label: `${hours[i]} (${startDay})`,
            value: hours[i],
            index: i,
            disabled: !shouldEnable(i),
          });
        }
        for (let i = 0; i <= endIdx; i++) {
          validSlots.push({
            label: `${hours[i]} (${endDay})`,
            value: hours[i],
            index: hours.length + i,
            disabled: !shouldEnable(i),
          });
        }
      } else {
        // Same-day plan
        for (let i = startIdx; i <= endIdx; i++) {
          validSlots.push({
            label: `${hours[i]} (${startDay})`,
            value: hours[i],
            index: i,
            disabled: !shouldEnable(i),
          });
        }
      }
    });

    // Sort by index to maintain chronological order
    validSlots.sort((a, b) => a.index - b.index);

    // Remove duplicates (using label-value as the key)
    const uniqueSlotsMap = new Map();
    for (const slot of validSlots) {
      const key = `${slot.label}-${slot.value}`;
      if (!uniqueSlotsMap.has(key)) {
        uniqueSlotsMap.set(key, slot);
      }
    }

    return Array.from(uniqueSlotsMap.values());
  };

  const getClosingPlanHours = (planName) => {
    const validSlots = [];
    const editingPlan = editingPlans[planName];

    if (!editingPlan) return [];

    const formattedDay = selectedDay

    // Extract only time part from "9:15 AM (Monday)"
    const rawStartTime = editingPlan?.starttime?.split('(')[0]?.trim();
    const rawEndTime = editingPlan?.endtime?.split('(')[0]?.trim();

    const startIdx = hours.indexOf(rawStartTime);
    const endIdx = hours.indexOf(rawEndTime);

    if (startIdx === -1 || endIdx === -1 || startIdx >= endIdx) return [];

    for (let i = startIdx + 1; i <= endIdx; i++) {
      validSlots.push({
        label: `${hours[i]} (${formattedDay})`,
        value: hours[i],
        index: i,
      });
    }

    return validSlots;
  };






  const handleCloseTimeChange = (e) => {


    setTimeSlots(prevState => ({
      ...prevState,
      endtime: e.target.value, // Store the label including the day
    }));

  };



  // Step 1: Generate hour labels
  const hoursLabel = Array.from({ length: 24 }, (_, i) => {
    const hour = i % 12 || 12;
    const suffix = i < 12 ? "AM" : "PM";
    const formattedHour = `${hour < 10 ? "0" + hour : hour}${suffix}`;
    // // console.log(`Step 1 - Hour Label for ${i}:`, formattedHour);
    return formattedHour;
  });
  // // console.log('Step 1 - All Hour Labels:', hoursLabel);

  // Step 2: Determine source of slots based on isActive state
  const slotsSource = isActive === "regular"
    ? singleSpot?.[0]?.daySpotDetails?.[0]?.spots
    : singleSplSpot?.daySpotDetails?.[0]?.spots;

  // // console.log('Step 2 - Slot Source:', slotsSource);

  // Step 3: Group the slots by hour + period (e.g., "09AM")
  const groupedSlots = Array.isArray(slotsSource)
    ? slotsSource.reduce((acc, slot, index) => {
      // // console.log(`Step 3 - Processing Slot ${index}:`, slot);

      const [time, period] = slot.spotstart.split(" "); // e.g., "09:00 AM"
      const hour = time.split(":")[0]; // "09"
      const hourKey = hour + period;   // e.g., "09AM"

      // // console.log(`Step 3 - Extracted hourKey:`, hourKey);

      if (!acc[hourKey]) {
        acc[hourKey] = { hourLabel: period, slots: [] };
        // // console.log(`Step 3 - Creating new group for hourKey ${hourKey}`);
      }

      acc[hourKey].slots.push(slot);
      // // console.log(`Step 3 - Added slot to hourKey ${hourKey}:`, acc[hourKey].slots);
      return acc;
    }, {})
    : {}; // fallback to empty object if no valid array

  // // console.log('Step 4 - Final Grouped Slots:', groupedSlots);


  // Step 1: Generate hour labels (keeping this the same)
  // const hoursLabel = Array.from({ length: 24 }, (_, i) => {
  //   const hour = i % 12 || 12;
  //   const suffix = i < 12 ? "AM" : "PM";
  //   const formattedHour = `${hour < 10 ? "0" + hour : hour}${suffix}`;
  //   return formattedHour;
  // });

  // Step 2: Determine source of slots based on isActive state (keeping this the same)
  // const slotsSource = isActive === "regular"
  //   ? singleSpot?.[0]?.daySpotDetails?.[0]?.spots
  //   : singleSplSpot?.daySpotDetails?.[0]?.spots;

  // Step 3: Extract unique days from the slots
  const uniqueDays = Array.isArray(slotsSource)
    ? [...new Set(slotsSource.map(slot => slot.day))]
    : [];

  // Step 4: Group the slots first by day and then by hour
  const slotsByDay = Array.isArray(slotsSource)
    ? slotsSource.reduce((acc, slot) => {
      const day = slot.day;
      const [time, period] = slot.spotstart.split(" "); // e.g., "09:00 AM"
      const hour = time.split(":")[0]; // "09"
      const hourKey = hour + period; // e.g., "09AM"

      // Initialize day if it doesn't exist
      if (!acc[day]) {
        acc[day] = {};
      }

      // Initialize hour in that day if it doesn't exist
      if (!acc[day][hourKey]) {
        acc[day][hourKey] = { hourLabel: period, slots: [] };
      }

      // Add slot to the appropriate day and hour
      acc[day][hourKey].slots.push(slot);
      return acc;
    }, {})
    : {};

  // Render the calendar table for each day
  const renderCalendarForDay = (day) => {
    const daySlots = slotsByDay[day] || {};

    return (
      <table className="table calander-grid mt-4" id={`calendar-table-${day}`} key={`table-${day}`}>
        <thead>
          <tr>
            <td className="timming-row" id="time-display"></td>
            <td colSpan="4" className="text-center day-show" id={`day-show-${day}`}>{day}</td>
          </tr>
        </thead>
        <tbody>
          {hoursLabel.map((hourKey) => {
            const hourData = (daySlots[hourKey]) || { slots: [] };
            return (
              <tr key={`${day}-${hourKey}`}>
                <td className="time-display">{hourKey}</td>
                {hourData.slots.map((slot) => (
                  <td key={slot.spotid} id={`slot-${slot.spotid}`}>
                    <button className="timming_slot" id={`slot-btn-${slot.spotid}`}>
                      <span>{slot.spotstart}</span>
                      <span>
                        {slot.plans.includes("Basic") && (
                          <img src={`${image}${appname}/images/web/Free-Badge.svg`} alt="Free Badge" id="free-badge" />
                        )}
                        {slot.plans.includes("Premium") && (
                          <img src={`${image}${appname}/images/web/Premium-Badge.svg`} alt="Premium Badge" id="premium-badge" />
                        )}
                        {slot.plans.includes("VIP") && (
                          <img src={`${image}${appname}/images/web/VIP-Badge.svg`} alt="VIP Badge" id="vip-badge" />
                        )}
                      </span>
                    </button>
                  </td>
                ))}
                {hourData.slots.length < 4 &&
                  Array(4 - hourData.slots.length)
                    .fill()
                    .map((_, i) => <td key={`empty-${i}-${day}-${hourKey}`}></td>)}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };



  const generateClosingOptions = () => {
    if (!timeSlots.starttime || !selectedDay) return [];

    const isRegular = isActive === "regular";
    const dayToUse = isRegular ? selectedDay : dayName;
    const currentDayIndex = days.indexOf(dayToUse);

    const openIndex = hours.indexOf(timeSlots.starttime.trim());
    if (openIndex === -1) return [];

    // Prepare disabled ranges from selected slots
    const disabledRanges = selectedSlots
      .map(slot => {
        const startIdx = hours.indexOf(slot.starttime.trim());
        let endIdx = hours.indexOf(slot.endtime.replace(/\s*\(\w+\)/, "").trim());

        const spansNextDay = endIdx < startIdx;
        if (spansNextDay) endIdx += hours.length;

        return { startIdx, endIdx, spansNextDay };
      })
      .filter(({ startIdx, endIdx }) => startIdx !== -1 && endIdx !== -1);

    // // console.log("Disabled Ranges:", disabledRanges);

    let closingOptions = [];

    // Find earliest conflict *after* start time
    let maxCloseIndex = openIndex + hours.length;
    for (let { startIdx } of disabledRanges) {
      if (startIdx > openIndex && startIdx < maxCloseIndex) {
        maxCloseIndex = startIdx;
      }
    }

    // Closing options for current day
    closingOptions = hours.map((time, i) => ({
      time,
      label: `${time} (${dayToUse})`,
      disabled: i <= openIndex || i >= maxCloseIndex,
    }));

    // Closing options for the next day
    const nextDay = days[(currentDayIndex + 1) % days.length];
    closingOptions.push(
      ...hours.map((time, i) => ({
        time,
        label: `${time} (${nextDay})`,
        disabled: i > maxCloseIndex - hours.length,
      }))
    );

    // // console.log("Final Closing Options:", closingOptions);
    return closingOptions;
  };



  const closingOptions = generateClosingOptions();

  const loginType = localStorage.getItem('login_type'); // 'admin' or 'client'
  const useruniqueid = localStorage.getItem("clientid")


  const closeAndReset = () => {
    setShowPoup(false)
    setTimeSlots({
      starttime: '',
      endtime: ''
    })
    setSelectedSlots([])
    setWorkingHours([])
    setSingleDayData([])
    setCategoryHours([])
    setPlans(plansData)
    setSelectedDate(null)
    setIsmodal(false)
    setShowSpecialHours(false)
    setSingleSplData({})
    setHasUnsavedChanges(false)
    setShowCloseConfirmPopup(false)
  }

  const handleClose = () => {
    if (categoryEditMode && isEditingCategory) {
      setPendingClose(true);
      setShowCategoryDiscardPopup(true);
    } else if (hasUnsavedChanges) {
      setShowCloseConfirmPopup(true);
    } else {
      closeAndReset();
    }
  }
  const handleDayClick = (day,) => {
    const formattedDay = day.trim().toUpperCase(); // Convert to uppercase for consistency

    const filteredSpots = spotsData.filter(
      (spot) => spot.spotday === formattedDay
    );
    const dayInCaps = day // example input
    const formattedDay1 = dayInCaps.charAt(0) + dayInCaps.slice(1).toLowerCase();
    console.log('hanlde day click=============================', day)
    // setSelectedDay(formattedDay1)
    setSelectedDay(day)
    setSelectedDays([day])
    setSingleSpot(filteredSpots);
    setIsOpen(filteredSpots?.[0]?.isopen ?? true)
    console.log("Filtered Spots:", filteredSpots);
  };

  const handleDateClick = (data) => {
    // const formattedDay = data.trim().toUpperCase(); 
    //  const filteredSpots = spotsData.filter(
    //   (spot) => spot.spotday === formattedDay
    // );
    console.log("datatatata-------------------------------->", data)
    setSingleSplSpot(data)
    // setIsOpen2(data?.isopen)
  }

  // console.log("isopen222-------------------------------->", isOpen2)

  const handleAddWork = () => {
    if (isActive === "regular") {
      setShowPoup(true)
    } else {
      setShowSpecialHours(true)
    }

  }
  // // console.log("selectedddddddddddddddd--------->", selectedDay)
  // // console.log("selecteddddddddddddddddNEwwwwwww--------->", selectedDayNew)
  // // console.log('pricePerSpot',pricePerSpot)
  // // console.log('maxvistiore',maxVisitors)
  // useEffect(() => {
  //   getStore()
  //   userActivity()
  // }, [])
  useEffect(() => {
    if (storeId) {
      getStore(storeId);   // <-- auto load clicked store
    }
    userActivity()
  }, [storeId]);
  useEffect(() => {
    // // console.log("Updated Selected Days:", selectedDays);
  }, [selectedDays]);
  useEffect(() => {

    if (window.site === undefined) {
      setTimeout(() => {
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
          setImg(window.site.common.imageCloudfront)
        }
      }, 1000);
    }
    if (window.site && window.site.common && window.site.common.imageCloudfront) {
      setImg(window.site.common.imageCloudfront)
    }



  }, [window.site]);


  const handlePlanSdata = (e) => {
    // console.log("e.target.value---------------------->", e.target.value)
  }



  const handleAddSlot = () => {
    if (!timeSlots.starttime || !timeSlots.endtime) {
      alert("Please select a valid time slot.");
      return;
    }

    setSelectedSlots((prevSlots) => {
      let updatedSlots;
      let newSlotId = timeSlots.id || (prevSlots.length > 0 ? Math.max(...prevSlots.map(slot => slot.id)) + 1 : 1);

      if (timeSlots.id) {
        // Update existing slot
        updatedSlots = prevSlots.map(slot =>
          slot.id === timeSlots.id ? { ...slot, starttime: timeSlots.starttime, endtime: timeSlots.endtime } : slot
        );
      } else {
        // Create a new slot with a unique ID
        const newSlot = {
          id: newSlotId,
          starttime: timeSlots.starttime,
          endtime: timeSlots.endtime
        };
        updatedSlots = [...prevSlots, newSlot];
      }

      setPlans((prevPlans) => {
        if (timeSlots.id) {

          return prevPlans.map(plan =>
            plan.id === timeSlots.id ? { ...plan, starttime: timeSlots.starttime, endtime: timeSlots.endtime } : plan
          );
        }

        if (prevSlots.length === 0) {
          // First slot: Modify only the first two default objects
          return prevPlans.map((plan, index) =>
            index < 2 ? { ...plan, starttime: timeSlots.starttime, endtime: timeSlots.endtime, id: newSlotId } : plan
          );
        }

        // Subsequent slots: Create new objects for each base plan
        const basePlans = prevPlans.slice(0, 2); // First two objects are the base plans

        // Ensure the new slot is not already added
        const isSlotAlreadyAdded = prevPlans.some(
          plan => plan.starttime === timeSlots.starttime && plan.endtime === timeSlots.endtime
        );

        if (isSlotAlreadyAdded) return prevPlans; // Prevent duplicates

        const newSlotPlans = basePlans.map(plan => ({
          ...plan,
          starttime: timeSlots.starttime,
          endtime: timeSlots.endtime,
          id: newSlotId
        }));

        return [...prevPlans, ...newSlotPlans];
      });

      return updatedSlots;
    });

    setTimeSlots({ starttime: "", endtime: "" });

  };





  // // console.log("planssssssssssssssssssssssss", plans)
  // // console.log("selectedSlotsssssssssssssssssssssssss", selectedSlots)

  const handleDeleteSlot = (data) => {
    const updatedSlots = selectedSlots.filter((item) => item?.id !== data?.id);
    setSelectedSlots(updatedSlots);
    const updatedPlans = plans.map((item) => {
      if (
        item?.id === data?.id &&
        item?.starttime === data?.starttime &&
        item?.endtime === data?.endtime
      ) {
        const { starttime, endtime, ...rest } = item;
        return rest; // return object without starttime and endtime
      }
      return item; // return unchanged
    });

    setPlans(updatedPlans);
  };

  const handleDaySelect = (day) => {
    setSelectedDays((prevDays) => {
      if (prevDays.includes(day)) {
        // If day exists, remove it
        return prevDays.filter((d) => d !== day);
      } else {
        // Otherwise, add it
        return [...prevDays, day];
      }
    });
  };
  // // console.log('singleDayData', singleDayData)
  const handleIsStoreOpen = (isopenvalue = null, storespotdayid) => {
    setLoaderEnable(true)
    // setCommonLoader(true)
    // // console.log('isopenvalue', isopenvalue)
    // // console.log('storespotdayid', storespotdayid)
    const token = localStorage.getItem("token");
    const payload = {
      storeid: formData?.storeid,
      spotdaystartend: singleSpot?.[0]?.spotdaystartend,
      spotdayplanstartend: singleSpot?.[0]?.spotdayplanstartend,
      createdBy: {
        userId: userData?.clientid,
      },
    };

    // Set the `isOpen` state if provided
    if (isopenvalue !== null) {
      setIsOpen(isopenvalue);
      payload.isopen = isopenvalue; // Add the `isopen` value to the payload if it's not null
    }

    // Handle payload specifics based on the spot type
    if (isActive === 'regular') {
      payload.spotstype = "REGULAR";

    } else {
      payload.spotstype = "SPECIAL";
      payload.days = [dayName];
    }

    // Construct the URL for the API
    const url = `${lambda}/updateSpots?appname=${appname}&token=${token}&storespotdayid=${storespotdayid}`;

    // Make the API request
    axios({
      method: 'POST',
      url: url,
      data: payload,
    })
      .then(function (response) {
        if (response) {
          if (response?.result === "Invalid token or Expired") {
            setShowSessionPopupup(true);
          } else {
            setSuccessMessage(isopenvalue ? "Store opened successfully" : "Store closed successfully");
            setShowSuccessPopup(true);
            getSpots(formData?.storeid);
            setSelectedSlots([]);
            setPlans([]);
            // setSelectedDate(null);
          }

        }
      })
      .catch((error) => {
        console.error("Error updating store open status:", error);
      });
  };

  const handleIsStoreOpen2 = (isopenvalue = null, storespotdayid, isModal = null) => {
    if (isModal) {
      setIsmodal(true)
    }
    console.log('isopenvalue', isopenvalue)

    setLoaderEnable(true)
    // setCommonLoader(true)
    // // console.log('isopenvalue', isopenvalue)
    // // console.log('storespotdayid', storespotdayid)
    const token = localStorage.getItem("token");
    const payload = {
      storeid: formData?.storeid,
      spotdaystartend: singleSplSpot?.spotdaystartend,
      spotdayplanstartend: singleSplSpot?.spotdayplanstartend,
      createdBy: {
        userId: userData?.clientid,
      },
    };

    // Set the `isOpen` state if provided
    if (isopenvalue !== null) {
      // setIsOpen2(isopenvalue);
      payload.isopen = isopenvalue; // Add the `isopen` value to the payload if it's not null
    }

    // Handle payload specifics based on the spot type
    // if (isActive === 'regular') {
    //   payload.spotstype = "REGULAR";

    // } else {
    payload.spotstype = "SPECIAL";
    // payload.days = [dayName];
    // }

    // Construct the URL for the API
    const url = `${lambda}/updateSpots?appname=${appname}&token=${token}&storespotdayid=${storespotdayid}`;

    // Make the API request
    axios({
      method: 'POST',
      url: url,
      data: payload,
    })
      .then(function (response) {
        if (response) {
          if (response?.result === "Invalid token or Expired") {
            setShowSessionPopupup(true);
          } else {
            setSuccessMessage(isopenvalue ? "Store opened successfully" : "Store closed successfully");
            setShowSuccessPopup(true);
            getSpots(formData?.storeid, isModal);
            setSelectedSlots([]);
            setPlans([]);
            // setSelectedDate(null);
          }

        }
      })
      .catch((error) => {
        console.error("Error updating store open status:", error);
      });
  };
  // // console.log('selectdaysssssssssss',selectedDays)


  const handleCalender = () => {
    let effectiveCategoryHours = categoryHours;

    // Determine correct open/closed state for regular vs special hours
    const isSpecialHoursContext = isActive === 'special' || showSpecialHours;
    const isLocationOpen = isSpecialHoursContext
      ? (singleSplData?.storespotdayid ? (singleSplSpot?.isopen ?? true) : isStoreOpen)
      : isOpen;

    // Skip hours validation when the location is marked as closed
    if (isLocationOpen) {
      if (workingHours.length <= 0) {
        setToastMessage("Enter working hours to proceed.");
        setToastType("error");
        return;
      }

      // Auto-add pending plan hours the user filled in but forgot to click ADD
      if (selectedCategoryStartTime && selectedCategoryEndTime && !categoryEditMode) {
        const planConfig = categoryTypes[activeCategoryIndex];
        const categoryPlan = planConfig?.plan;
        const mv = Number(maxVisitors) || 0;
        const planAllocation = Number(planConfig?.maxvisitors) || 0;

        if (categoryPlan && mv > 0 && (planAllocation === 0 || mv <= planAllocation)) {
          const startTime = parseTimeString(selectedCategoryStartTime);
          const endTime = parseTimeString(selectedCategoryEndTime);
          const isOvernight = endTime.hour < startTime.hour ||
            (endTime.hour === startTime.hour && endTime.minute < startTime.minute);
          const autoHour = {
            plan: categoryPlan,
            price: pricePerSpot || planConfig.price,
            active: planConfig.active,
            maxvisitors: mv,
            starttime: selectedCategoryStartTime,
            endtime: selectedCategoryEndTime,
            day: selectedDay,
            endDay: isOvernight ? getNextDay(selectedDay) : selectedDay,
            id: findWorkingHourIdForTimeRange(selectedCategoryStartTime, selectedCategoryEndTime)
          };
          effectiveCategoryHours = [...categoryHours, autoHour];
          setCategoryHours(effectiveCategoryHours);
          clearCategoryForm(activeCategoryIndex);
        }
      }

      // Check for missing plans using the effective (possibly auto-added) hours
      const missing = categoryTypes
        .filter(ct => !effectiveCategoryHours.some(h => h.plan === ct.plan))
        .map(ct => ct.plan);
      if (missing.length > 0) {
        setMissingPlans(missing);
        setShowPlanWarningModal(true);
        return;
      }
    }

    proceedWithCalender(effectiveCategoryHours);
  };
  const proceedWithCalender = (overrideCategoryHours = null) => {
    setShowPlanWarningModal(false);
    setLoaderEnable(true);
    const token = localStorage.getItem("token");
    const finalCategoryHours = overrideCategoryHours ?? categoryHours;
    let payload = {};

    if (isActive === 'regular') {
      payload = {
        storeid: formData?.storeid,
        spotstype: "REGULAR",
        spotdaystartend: workingHours,
        spotdayplanstartend: finalCategoryHours,
        createdBy: {
          userId: userData?.clientid
        },
        days: selectedDays
      };
    } else {
      payload = {
        storeid: formData?.storeid,
        spotstype: "SPECIAL",
        spotdaystartend: workingHours,
        spotdayplanstartend: finalCategoryHours,
        spotspecialfromdate: selectedDate,
        spotspecialtodate: selectedDate,
        createdBy: {
          userId: userData?.clientid
        },
        days: [dayName]
      };
    }

    if (!singleDayData?.storespotdayid && !singleSplData?.storespotdayid) {
      payload.isopen = isStoreOpen;
    }
    // Always include isopen for regular hours so closed status is saved
    if (isActive === 'regular') {
      payload.isopen = isOpen;
    }
    const url = selectedDays?.length > 1 && singleDayData?.storespotdayid ? `${lambda}/updateSpots?appname=${appname}&token=${token}&schedule_days=${true}`
      : singleDayData?.storespotdayid || singleSplData?.storespotdayid
        ? `${lambda}/updateSpots?appname=${appname}&token=${token}&storespotdayid=${singleDayData?.storespotdayid ?? singleSplData?.storespotdayid}`
        : `${lambda}/addSpots?appname=${appname}&token=${token}`;

    axios({
      method: 'POST',
      url: url,
      data: payload,
    })
      .then(function (response) {
        if (response) {
          if (response?.result === "Invalid token or Expired") {
            setShowSessionPopupup(true)
          } else {
            getSpots(formData?.storeid)
            setSelectedSlots([])
            setPlans([])

            setIsStoreOpen(true);

          }
        }
      });
    setShowcalender(true)
  }

  const handleCalenderOld = () => {
    if (workingHours.length <= 0) {
      setToastMessage("Enter working hours to proceed.");
      setToastType("error");
      return;
    }

    setLoaderEnable(true);
    const token = localStorage.getItem("token");
    let payload = {};


    if (isActive === 'regular') {
      payload = {
        storeid: formData?.storeid,
        spotstype: "REGULAR",
        spotdaystartend: workingHours,
        spotdayplanstartend: categoryHours,
        createdBy: {
          userId: userData?.clientid
        },
        days: selectedDays
      };


    } else {
      payload = {
        storeid: formData?.storeid,
        spotstype: "SPECIAL",
        spotdaystartend: workingHours,
        spotdayplanstartend: categoryHours,
        spotspecialfromdate: selectedDate,
        spotspecialtodate: selectedDate,
        createdBy: {
          userId: userData?.clientid
        },
        days: [dayName]
      };
    }

    const url = selectedDays?.length > 1 && singleDayData?.storespotdayid ? `${lambda}/updateSpots?appname=${appname}&token=${token}&schedule_days=${true}`
      : singleDayData?.storespotdayid || singleSplData?.storespotdayid
        ? `${lambda}/updateSpots?appname=${appname}&token=${token}&storespotdayid=${singleDayData?.storespotdayid ?? singleSplData?.storespotdayid}`
        : `${lambda}/addSpots?appname=${appname}&token=${token}`;

    axios({
      method: 'POST',
      url: url,
      data: payload,
    })
      .then(function (response) {
        if (response) {
          if (response?.result === "Invalid token or Expired") {
            setShowSessionPopupup(true)
          } else {
            getSpots(formData?.storeid)
            setSelectedSlots([])
            setPlans([])


          }

        }

      });
    setShowcalender(true)

  }



  const handleChange = (selected) => {
    setSelectedOptions(selected);
  };

  const handleClick = (value) => {
    setIsActive(value)
  }
  // // console.log("timeSlotsssssssssssssssssssssssssssssssssssssssssssss", timeSlots)
  // // console.log("single day data", singleDayData)
  const getMatchingDays = (currentSpot, allSpots) => {
    const wh = currentSpot?.spotdaystartend ?? [];
    const ph = currentSpot?.spotdayplanstartend ?? [];
    return allSpots
      .filter(s => {
        if (s.spotday === currentSpot?.spotday) return false;
        const swh = s.spotdaystartend ?? [];
        const sph = s.spotdayplanstartend ?? [];
        if (swh.length !== wh.length || sph.length !== ph.length) return false;
        const whMatch = wh.every((h, i) => swh[i]?.starttime === h.starttime && swh[i]?.endtime === h.endtime);
        const phMatch = ph.every((p, i) =>
          sph[i]?.plan === p.plan &&
          sph[i]?.starttime === p.starttime &&
          sph[i]?.endtime === p.endtime &&
          sph[i]?.price === p.price &&
          sph[i]?.maxvisitors === p.maxvisitors
        );
        return whMatch && phMatch;
      })
      .map(s => s.spotday);
  };

  const handleEditHour = (data) => {
    // // console.log("datatatatatatatatatatatattatatatata", data)
    setSingleDayData(data?.[0])
    setSelectedDay(
      data?.[0]?.spotday
      // ? data[0].spotday.charAt(0).toUpperCase() + data[0].spotday.slice(1).toLowerCase()
      // : ''
    );
    const matchingDays = getMatchingDays(data?.[0], spotsData);
    setSelectedDays([data?.[0]?.spotday, ...matchingDays])
    setPlans(data?.[0]?.spotdayplanstartend)
    setSelectedSlots(data?.[0]?.spotdaystartend)
    setWorkingHours(data?.[0]?.spotdaystartend)
    const syncedCategoryHours = (data?.[0]?.spotdayplanstartend ?? []).map(ch => {
      const planConfig = categoryTypes.find(ct => ct.plan === ch.plan);
      return planConfig ? { ...ch, maxvisitors: planConfig.maxvisitors, price: planConfig.price } : ch;
    });
    setCategoryHours(syncedCategoryHours)
    setShowPoup(true)
  }
  const handleBack = () => {
    navigate("/spots")
  }
  const handleEditTime = (data) => {
    // // console.log("datatatatatatatattata", data)
    setTimeSlots(data)
  }
  const handleEditPlanTime = (plan) => {
    setEditingPlans(prev => {
      const updated = {
        ...prev,
        [plan.plan]: plan,
      };
      // // console.log("Edited Plans:", updated);
      return updated;
    });
  };

  const handleAddPlan = (data) => {
    // // console.log("DATATATATATTATATAATATATATA", data)
    const updatedValues = editingPlans[data.name]; // data.name = "Premium"
    // // console.log("UpdatedValuesssssssssssssssssssssssssssssssssssssssssssssssssssss", updatedValues)
    setPlans((prevPlans) =>
      prevPlans.map((plan) =>
        plan.id === updatedValues.id && plan.plan === data.name
          ? { ...plan, ...updatedValues }
          : plan
      )
    );

    // Clean up editingPlans
    setEditingPlans((prev) => {
      const updated = { ...prev };
      delete updated[data.name];
      return updated;
    });
  };

  // // console.log('activeCategoryIndex',activeCategoryIndex)

  const handleEditChange = (e, planName) => {
    const { name, value } = e.target;
    // // console.log("valueeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", value)
    setEditingPlans((prev) => ({
      ...prev,
      [planName]: {
        ...prev[planName],
        [name]: value, // value already includes time + (Day)
      },
    }));
  };





  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const formatDateUS = (dateStr) => {
    if (!dateStr) return '';

    // Extract YYYY-MM-DD only (ignore time & timezone)
    const [year, month, day] = dateStr.split('T')[0].split('-');

    return `${month}-${day}-${year}`;
  };



  const handleDateClickw = (data) => {
    // // console.log("datatatata-------------------------------->", data)
    setSingleSplSpot(data)
  }

  const handleAddSpot = () => {
    setHasUnsavedChanges(false);
    setShowSpecialHours(true);
  }
  // const fetchStoreDetails = async (storeId) => {
  //   try {
  //     setLoading(true);

  //     const response = await API.get(
  //       `/store/details?storeid=${storeId}`
  //     );

  //     if (response?.data?.success) {
  //       setStoreDetails(response.data.data);
  //     } else {
  //       setStoreDetails(null);
  //     }
  //   } catch (error) {
  //     console.error("Store details load error:", error);
  //     setStoreDetails(null);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // // console.log("editinggggggPlan", editingPlans)
  // const getStore = (e) => {
  //   setIsLoading(true)
  //   // GetTimeActivity()
  //   const token = localStorage.getItem("token")
  //   axios({
  //     method: 'POST',
  //     url: `${lambda}/getStores?appname=${appname}&userid=${useruniqueid}&storeid=${id}&token=${token}`,
  //     // + "&token=" + token,
  //   })
  //     .then(function (response) {
  //       if (response?.data?.result === "Invalid token or Expired") {
  //         setShowSessionPopupup(true)
  //       } else {
  //         if (response?.data?.result) {
  //           const result = response?.data?.result?.[0];
  //           setFormData(result)
  //           getSpots(result?.storeid)

  //           if (result?.preferences) {
  //             const activePlans = Object.values(result.preferences).filter(plan => plan.active); // Extract only active plans

  //             const FindMembers = Object.keys(result?.preferences || {}).reduce((acc, key) => {
  //               const item = result.preferences[key];
  //               if (item?.name) {
  //                 acc[item.name] = Math.floor((item?.percentage / 100) * result?.maxVisitor);
  //               }
  //               return acc;
  //             }, {});
  //             // // console.log("FindMemberssssssssssssssssssssssssssssss", FindMembers)
  //             const formattedPlans = activePlans.map(plan => {

  //               const maxVisitors = FindMembers[plan.name] !== undefined ? FindMembers[plan.name] : 0;
  //               return {
  //                 plan: plan.name || "",
  //                 active: plan.active,
  //                 price: Number(plan.price) || 0,
  //                 maxvisitors: maxVisitors,
  //               };
  //             });
  //             // // console.log('formattedPlans', formattedPlans)
  //             setPlansData(formattedPlans)
  //             // setHourCategories({...hourCategories,...formattedPlans })
  //             // Mapping from plan names to hour category labels
  //             const planToCategoryName = {
  //               Basic: "BASIC HOURS",
  //               Premium: "PREMIUM HOURS",
  //               VIP: "VIP HOURS"
  //             };

  //             const newHourCategories = formattedPlans.map(plan => ({
  //               name: planToCategoryName[plan.plan] || plan.plan.toUpperCase() + " HOURS",
  //               hours: [],
  //               ...plan
  //             }));
  //             setHourCategories(newHourCategories);



  //             // Mapping formattedPlans to categoryTypes format
  //             const updatedCategoryTypes = formattedPlans.map(plan => {
  //               return {
  //                 name: `${plan.plan.toUpperCase()} HOURS`, // Adjust name formatting as needed
  //                 plan: plan.plan,
  //                 price: plan.price,
  //                 active: plan.active,
  //                 maxvisitors: plan.maxvisitors
  //               };
  //             });

  //             // Update the state
  //             setCategoryTypes(updatedCategoryTypes);
  //             // // console.log(updatedCategoryTypes);
  //             setPlans(formattedPlans);

  //           }



  //         } else {
  //           // setInvalidContent(true)
  //         }

  //       }

  //       // setDisableSaveBtn(false)
  //     });
  // }
  // // console.log("singleSpotttttttttttttttttttttttttttttttt", spotsData)

  const getStore = async (storeIdParam = null) => {
    try {
      setIsLoading(true);

      const token = localStorage.getItem("token");
      const storeIdToLoad = storeIdParam || storeId;

      if (!storeIdToLoad || !token) {
        setIsLoading(false);
        return;
      }

      const response = await axios({
        method: 'POST',
        url: `${lambda}/getStores?appname=${appname}&userid=${useruniqueid}&storeid=${storeIdToLoad}&token=${token}`,
      });

      if (response?.data?.result === "Invalid token or Expired") {
        setShowSessionPopupup(true);
        return;
      }

      const result = response?.data?.result?.[0];

      if (!result) {
        setFormData(null);
        setPlans([]);
        setPlansData([]);
        setHourCategories([]);
        setCategoryTypes([]);
        setIsLoading(false);
        return;
      }

      /* ================= STORE BASIC DETAILS ================= */
      setFormData(result);

      /* ================= PLANS & PREFERENCES ================= */
      if (result?.preferences && typeof result.preferences === "object") {

        const activePlans = Object.values(result.preferences).filter(
          plan => plan?.active === true
        );

        console.log("Active Plans:", activePlans);

        console.log("Result Preferences:", result.preferences);

        console.log("Max result :", result);

        const FindMembers = (() => {
          const maxVisitor = result?.maxVisitor || 0;
          const allocs = {};
          const fracs = [];
          activePlans.forEach(item => {
            if (!item?.name) return;
            const exact = (item.percentage / 100) * maxVisitor;
            allocs[item.name] = Math.floor(exact);
            fracs.push({ name: item.name, frac: exact - Math.floor(exact) });
          });
          let rem = maxVisitor - Object.values(allocs).reduce((s, v) => s + v, 0);
          fracs.sort((a, b) => b.frac - a.frac);
          for (let i = 0; i < rem && i < fracs.length; i++) allocs[fracs[i].name]++;
          return allocs;
        })();

        const formattedPlans = activePlans.map(plan => ({
          plan: plan?.name || "",
          active: plan?.active || false,
          price: Number(plan?.price || 0),
          percentage: Number(plan?.percentage || 0),
          maxvisitors: FindMembers?.[plan?.name] || 0,
        }));

        setPlansData(formattedPlans);
        setPlans(formattedPlans);

        /* ================= HOUR CATEGORIES ================= */
        const planToCategoryName = {
          Basic: "BASIC HOURS",
          Premium: "PREMIUM HOURS",
          VIP: "VIP HOURS",
        };

        const newHourCategories = formattedPlans.map(plan => ({
          name: planToCategoryName[plan.plan] || `${plan.plan.toUpperCase()} HOURS`,
          hours: [],
          ...plan,
        }));

        setHourCategories(newHourCategories);

        /* ================= CATEGORY TYPES ================= */
        const updatedCategoryTypes = formattedPlans.map(plan => ({
          name: `${plan.plan.toUpperCase()} HOURS`,
          plan: plan.plan,
          price: plan.price,
          active: plan.active,
          percentage: plan?.percentage,
          maxvisitors: plan.maxvisitors,
        }));

        setCategoryTypes(updatedCategoryTypes);
        if (result?.storeid) {
          getSpots(result.storeid, null, true, updatedCategoryTypes);
        }
      } else {
        setPlans([]);
        setPlansData([]);
        setHourCategories([]);
        setCategoryTypes([]);
        if (result?.storeid) {
          getSpots(result.storeid, null, true, []);
        }
      }

    } catch (error) {
      console.error("Store load error:", error);
      setFormData(null);
    } finally {
      setIsLoading(false);
    }
  };


  useEffect(() => {
    autoOpenEditHoursRef.current = autoOpenEditHours;
  }, [autoOpenEditHours]);

  useEffect(() => {
    categoryTypesRef.current = categoryTypes;
  }, [categoryTypes]);

  // When showSpecialHours becomes false
  useEffect(() => {
    if (!showSpecialHours && !showPopup) {
      setWorkingHours([]);
      setCategoryHours([]);
      setActiveCategoryIndex(0);
      setEditMode(false);
      setSingleDayData([]);
      setSelectedStartTime("");
      setSelectedEndTime("");
      setSingleSplData({});
      setSelectedDate(null);
      setMaxVisitors(0);
      setPricePerSpot(0);
      setCategoryEditMode(false);
      setIsEditingCategory(false);
    }
  }, [showSpecialHours, showPopup]);

  const handleEditSpecial = (data) => {
    setSingleSplData(data)
    setWorkingHours(data?.spotdaystartend)
    setCategoryHours(data?.spotdayplanstartend)
    setSelectedDate(data?.spotspecialfromdate)
    setSelectedDay(data?.spotday)
    setDayName(data?.spotday);
    setHasUnsavedChanges(false);
    setShowSpecialHours(true)
  }

  const handleDeleteSpecialHour = (item) => {
    setDeleteSpecialHourItem(item);
    setShowDeleteSpecialHourPopup(true);
  };

  const confirmDeleteSpecialHour = () => {
    if (!deleteSpecialHourItem?.storespotdayid) return;
    const token = localStorage.getItem('token');
    setLoaderEnable(true);
    axios({
      method: 'POST',
      url: `${lambda}/updateSpots?appname=${appname}&token=${token}&storespotdayid=${deleteSpecialHourItem.storespotdayid}&userid=${userData?.clientid}`,
      data: { storeid: formData?.storeid, status: 'ARCHIVE' }
    }).then(() => {
      setShowDeleteSpecialHourPopup(false);
      setDeleteSpecialHourItem(null);
      setLoaderEnable(false);
      setSuccessMessage("Special hours deleted successfully");
      setShowSuccessPopup(true);
      getSpots(formData?.storeid);
    }).catch(() => {
      setLoaderEnable(false);
    });
  };
  const getSpots = (Id, value = null, isInitialLoad = false, planTypes = []) => {
    setLoaderEnable(true)
    const token = localStorage.getItem("token")
    axios({
      method: 'GET',
      url: lambda + '/getSpots?appname=' + appname + "&storeid=" + Id + "&token=" + token,
    })
      .then(function (response) {
        if (response?.data?.result === "Invalid token or Expired") {
          setShowSessionPopupup(true)
        } else {
          const result = response?.data?.result?.filter((item) => item?.spotstype === "REGULAR")
          const filterSpotDay = result?.filter((day) => day?.spotday === selectedDay)
          // // console.log("filterSpotDay---->", spotDay, filterSpotDay)
          setSpotsData(result)


          // // console.log("Resulttttttttttttttttttttttttttttttttttttttttttttttttttttt",result?.length)
          // setSingleSpot(filterSpotDay)
          // setTimeout(() => {
          setSingleSpot(filterSpotDay);
          setIsOpen(filterSpotDay?.[0]?.isopen ?? true)
          // setCommonLoader(false)
          setLoaderEnable(false)
          // }, 1000);
          const specialSpots = response?.data?.result?.filter((day) => day?.spotstype === "SPECIAL")
          // // console.log("specialSpots------------------------->", specialSpots)
          setSpecialSpotData(specialSpots)
          setSingleSplSpot(specialSpots?.[0])
          // setIsOpen2(specialSpots?.[0]?.isopen)
          setIsLoading(false)
          // // console.log('singleSplSpotttttttttttttttttttttttttttttttttttttttttttttt',specialSpots?.[0])
          if (isInitialLoad && autoOpenEditHoursRef.current) {
            const daysOrder = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
            const firstSpot = daysOrder
              .map(day => result.find(s => s.spotday === day))
              .find(s => s && (s.spotdaystartend?.length > 0 || s.spotdayplanstartend?.length > 0));
            if (firstSpot) {
              setSingleDayData(firstSpot);
              setSelectedDay(firstSpot.spotday);
              setSelectedDays([firstSpot.spotday, ...getMatchingDays(firstSpot, result)]);
              setSingleSpot([firstSpot]);
              setIsOpen(firstSpot?.isopen ?? true);
              setPlans(firstSpot.spotdayplanstartend);
              setSelectedSlots(firstSpot.spotdaystartend);
              setWorkingHours(firstSpot.spotdaystartend);
              const syncedCategoryHours = (firstSpot.spotdayplanstartend ?? []).map(ch => {
                const planConfig = planTypes.find(ct => ct.plan === ch.plan);
                return planConfig ? { ...ch, maxvisitors: planConfig.maxvisitors, price: planConfig.price } : ch;
              });
              setCategoryHours(syncedCategoryHours);
              setShowPoup(true);
              autoOpenEditHoursRef.current = false;
              onAutoOpenDone?.();

              // Silently update all days' plan hours with new maxvisitors in the background
              const currentCategoryTypes = planTypes.length > 0 ? planTypes : categoryTypesRef.current;
              if (currentCategoryTypes?.length > 0) {
                result.forEach(spot => {
                  if (!spot.storespotdayid || !spot.spotdayplanstartend?.length) return;
                  const needsUpdate = spot.spotdayplanstartend.some(ph => {
                    const planConfig = currentCategoryTypes.find(ct => ct.plan === ph.plan);
                    return planConfig && planConfig.maxvisitors !== ph.maxvisitors;
                  });
                  if (!needsUpdate) return;
                  const updatedPlanHours = spot.spotdayplanstartend.map(ph => {
                    const planConfig = currentCategoryTypes.find(ct => ct.plan === ph.plan);
                    return planConfig ? { ...ph, maxvisitors: planConfig.maxvisitors, price: planConfig.price } : ph;
                  });
                  axios({
                    method: 'POST',
                    url: `${lambda}/updateSpots?appname=${appname}&token=${token}&storespotdayid=${spot.storespotdayid}`,
                    data: {
                      storeid: spot.storeid,
                      spotstype: 'REGULAR',
                      spotdaystartend: spot.spotdaystartend,
                      spotdayplanstartend: updatedPlanHours,
                      createdBy: { userId: userData?.clientid },
                      days: [spot.spotday]
                    }
                  });
                });
              }
            }
            // isInitialLoad: don't call setShowPoup(false) — modal is either just opened or was already closed
          } else if (!isInitialLoad) {
            setShowPoup(false);
          }
          setHasUnsavedChanges(false)
          if (value === null) {
            setShowSpecialHours(false)
          }
          setLoaderEnable(false)

        }

      }).catch((err) => {
        // console.log('error', err);

      });
  }
  useEffect(() => {
    // // console.log('singleSpot------------------------->', singleSpot)
  }, [singleSpot])
  // // console.log('selectday', selectedDay)
  // // console.log('spotday', spotDay)

  // Naming the location's own paid plans makes the notice concrete - "Premium and
  // VIP spots are hidden" tells a client what they lose, where "paid plans" alone
  // leaves them to work it out from the grid.
  const paidPlanNames = (plansData || [])
    .filter(plan => Number(plan?.price) > 0)
    .map(plan => plan?.plan)
    .filter(Boolean);
  const paidPlanList = paidPlanNames.length > 1
    ? `${paidPlanNames.slice(0, -1).join(", ")} and ${paidPlanNames[paidPlanNames.length - 1]}`
    : paidPlanNames[0];

  const handleConnectBankAccount = () => {
    const activeStoreId = formData?.storeid || storeId;
    // Send them back to whichever page they clicked from - the standalone Spots
    // page, or the Spots tab inside Edit Location when this renders embedded.
    const nextRoute = activeStoreId
      ? (embedded ? `/editstore/${activeStoreId}` : `/spotsmanage/${activeStoreId}`)
      : "/dashboard";
    navigate("/connectbankaccount", { state: { nextRoute } });
  };

  return (

    <>
      {showSessionPopupup && <SessionPopup />}
      <LayoutWrapper embedded={embedded}>

        {/* Start right Content here  */}
        {isLoading && !loaderEnable ? <Loader /> :
          <div className={embedded ? "user-management spots" : "main-content user-management spots"}>

            <PageWrapper embedded={embedded}>

                {!embedded && (
                  <>
                <div className="row  breadcrumb">
                  <div className="col-lg-12">
                    <div className="d-flex align-items-center">

                      <div className="flex-grow-1">
                        <h4 className="mb-2 card-title">Spots</h4>

                      </div>
                      {/* {subValDashboard && subValDashboard.Add && subValDashboard.Add.display === true && */}
                      <div>
                        <button className="fill-btn-style"
                          id="back-button"
                          onClick={handleBack}
                          //  disabled={subValDashboard && subValDashboard.Add && subValDashboard.Add.enable === false}
                          style={{
                            backgroundColor: "transparent",
                            color: "#5d1cd8"
                          }}><span class="material-symbols-outlined" id="back-icon2">arrow_back</span>Back</button>
                      </div>
                      {/* } */}
                    </div>
                  </div>
                </div>

                <div className="row manage-hours">
                  <div className="col-12 Add-store-block">
                    <div className="card">
                      <div className="card-body d-flex align-items-center">
                        <h4 className="form-title mb-0" id="location-info-title">SELECT LOCATION</h4>
                        <div className="input-group">

                          <select
                            className="multi-select-style"
                            value={formData?.storeid || ""}
                            onChange={(e) => getStore(e.target.value)}
                          >
                            {/* <option value="">Select Location</option> */}

                            {storeList.map(store => (
                              <option key={store.storeid} value={store.storeid}>
                                {store.name}
                              </option>
                            ))}
                          </select>

                        </div>

                      </div>
                      {/* <div className="card-body d-flex align-items-center">
                        <h4 className="form-title mb-0 me-3" id="location-info-title">
                          STORE NAME :
                        </h4>

                        <input
                          type="text"
                          className="form-control"
                          value={formData?.name || ""}
                          id="store-name"
                          readOnly
                          style={{ maxWidth: "300px", backgroundColor: "#f5f5f5" }}
                        />
                      </div> */}
                    </div>
                  </div>
                </div>
                  </>
                )}

                <div className="row table-data">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        {canTakePaid === false && (
                          <div
                            id="spots-bank-gate-banner"
                            style={{
                              background: '#fefce8',
                              border: '1px solid #ca8a04',
                              borderRadius: '10px',
                              padding: '14px 18px',
                              marginBottom: '16px',
                              display: 'flex',
                              alignItems: 'flex-start',
                              gap: '12px'
                            }}
                          >
                            <span className="material-symbols-outlined" style={{ color: '#ca8a04', fontSize: '24px' }} aria-hidden="true">account_balance</span>
                            <div style={{ flex: 1 }}>
                              <h5 style={{ margin: 0, color: '#854d0e', fontWeight: 700, fontSize: '15px' }} id="spots-bank-gate-title">
                                {paidPaused ? "Paid bookings are paused" : "Connect your bank account to take paid bookings"}
                              </h5>
                              <p style={{ margin: '4px 0 0', color: '#854d0e', fontSize: '13.5px' }} id="spots-bank-gate-text">
                                {paidPaused
                                  ? "Stripe has paused transfers to your account, so SpotSaver can't send you your share of paid bookings right now. Your Business Profile shows what Stripe needs."
                                  : "Paid plans need a connected bank account - we can't collect a booking payment with nowhere to send it. You can save free ($0) plans in the meantime."}
                              </p>
                              <p style={{ margin: '4px 0 12px', color: '#854d0e', fontSize: '13.5px' }} id="spots-bank-gate-visibility-text">
                                {paidPlanNames.length > 0
                                  ? `Until then, ${paidPlanList} spots stay hidden from customers and can't be booked - only your free ($0) spots are bookable.`
                                  : "Until then, any paid spot you add stays hidden from customers and can't be booked - only free ($0) spots are bookable."}
                              </p>
                              <button
                                type="button"
                                className="fill-btn"
                                style={{ background: '#ca8a04', borderColor: '#ca8a04' }}
                                onClick={paidPaused ? () => navigate("/businessprofile") : handleConnectBankAccount}
                                id="spots-bank-gate-connect-btn"
                              >
                                {paidPaused ? "Open Business Profile" : "Connect bank account"}
                              </button>
                            </div>
                          </div>
                        )}
                        <ul className="nav nav-tabs nav-tabs-custom" role="tablist" id="tab-navigation">
                          <li className="nav-item" role="presentation" id="tab-regular-hours" style={{ cursor: "pointer" }} onClick={() => handleClick("regular")}>
                            <a className={`nav-link ${isActive === "regular" ? "active" : ""}`} id="link-regular-hours">
                              <span className="material-symbols-outlined">schedule</span>
                              <span className="d-none d-sm-block">REGULAR HOURS</span>
                            </a>
                          </li>

                          <li className="nav-item" role="presentation" id="tab-special-hours" style={{ cursor: "pointer" }} onClick={() => handleClick("special")}>
                            <a className={`nav-link ${isActive === "special" ? "active" : ""}`} id="link-special-hours">
                              <span className="material-symbols-outlined">kid_star</span>
                              <span className="d-none d-sm-block">SPECIAL HOURS</span>
                            </a>
                          </li>
                        </ul>

                        {/* spots tab start */}



                        {/* spots tab Start */}
                        <div className="tab-content p-3 text-muted">

                          {/* REGULAR HOURS TAB */}
                          <div className={`tab-pane ${isActive === "regular" ? "active show" : ""} weekly-section`}
                            id="home1" role="tabpanel">

                            {/* Weekend tab start */}

                            {/* Weekend Monday */}

                            {spotsData?.length > 0 ? loaderEnable ? <>
                              <Loader />
                            </> : !loaderEnable && (
                              <>
                                <ul className="nav nav-pills weekly-wrapper" id="pills-tab" role="tablist">
                                  {daysOfWeek.map(day => (
                                    <li className="nav-item" role="presentation" key={day}>
                                      <button
                                        onClick={() => handleDayClick(day)}
                                        className={`nav-link week-btn ${selectedDay === day ? 'active' : ''}`}
                                        id={`pills-${day}-tab`}
                                        data-bs-toggle="pill"
                                        data-bs-target={`#Week-${day}`}
                                        type="button"
                                        role="tab"
                                      >
                                        {day}
                                      </button>
                                    </li>
                                  ))}
                                </ul>

                                {singleSpot?.length > 0 ? (
                                  <div className="tab-pane fade show active" id="Week-Mon" role="tabpanel" aria-labelledby="Week-Mon">
                                    <div className="row store">
                                      <div className="col-md-3">
                                        {/* left side store panel */}
                                        <div className="store-panel-left">
                                          <div>
                                            <h4 className="form-title mb-0" id="location-info-title">LOCATION WORKING HOURS</h4>


                                            <div className="input-field switch-buttons d-flex align-items-center mt-2" style={{ gap: '10px', minHeight: '34px' }}>
                                              <label className="col-form-label p-0 me-2" style={{ color: isOpen ? '#198754' : '#dc3545', fontWeight: 700 }}>Location {isOpen ? 'Open' : 'Closed'}</label>
                                              <label className="switch disable mb-0">
                                                <Tooltip title={isOpen ? "Click to close the store" : "Click to open the store"}>  <input
                                                  type="checkbox"
                                                  id="store-open-checkbox"
                                                  checked={isOpen}
                                                  disabled={loaderEnable}
                                                  title='kkkkk'
                                                  //  title={isOpen ? "Click to close the store" : "Click to open the store"}
                                                  onChange={() => handleIsStoreOpen(!isOpen, singleSpot?.[0]?.storespotdayid)}
                                                />
                                                  <span className="slider round"></span>
                                                </Tooltip>
                                              </label>

                                              {/* <small className="text-muted">Toggle to set the store as open or closed.</small> */}

                                            </div>



                                          </div>
                                          <div style={!isOpen ? { opacity: 0.4, pointerEvents: 'none', userSelect: 'none' } : {}}>
                                          {!isOpen && (
                                            <div className="d-flex align-items-center gap-1 mt-3" style={{ color: '#dc3545', fontSize: '12px', fontWeight: 600 }}>
                                              <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>block</span>
                                              Location closed — hours inactive
                                            </div>
                                          )}
                                          {singleSpot?.[0]?.spotdaystartend?.map((item, index) => (
                                            <button
                                              key={index}
                                              className="time-fill-btn w-100 mt-4 d-flex align-items-center justify-content-center"
                                              id={`time-btn-${index}`}
                                            >
                                              <span className="material-symbols-outlined me-2 flex-shrink-0">schedule</span>
                                              <span className="text-center">{`${formatTimeForDisplay(item?.starttime, item?.day)} to ${formatTimeForDisplay(item?.endtime, item?.endDay)}`}</span>
                                            </button>
                                          ))}
                                          </div>
                                          <button
                                            className="outline_btn d-flex align-items-center justify-content-center mt-4"
                                            id="edit-hours-btn"
                                            onClick={() => handleEditHour(singleSpot)}
                                          >
                                            <span className="material-symbols-outlined me-2">edit_calendar</span>Edit Hours
                                          </button>
                                        </div>
                                      </div>

                                      {/* right side store panel */}
                                      <div className="col-md-9 ps-1">
                                        <div className="store-panel-right">
                                          <div style={{ height: 500 }} className="calander-block">
                                            {singleSpot?.[0]?.isopen === false ?
                                              <div className="container text-center" id="store-closed-message">
                                                <div className="image-container">
                                                  <img
                                                    src={`${image}${appname}/images/web/Store-Closed.svg`}
                                                    alt="No spots available"
                                                    className="img-fluid"
                                                    style={{ maxWidth: "300px" }}
                                                    id="store-closed-image"
                                                  />
                                                </div>
                                                <h5 className="mt-3 fw-bold" style={{ color: '#dc3545' }} id="store-closed-title">Location Closed</h5>
                                                <p className="text-muted" id="store-closed-info">Toggle the switch to open this location.</p>
                                              </div> :

                                              <>
                                               {uniqueDays.length > 0 && <h4 className="form-title mb-0" id="paid-plans-title">PAID PLANS</h4>}


                                                {uniqueDays.length > 0 ? (
                                                  uniqueDays.map(day => renderCalendarForDay(day))
                                                ) : (
                                                  <h4 className="form-title mb-0 text-center">No slots available</h4>
                                                )}
                                              </>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) :


                                  !commonLoader && (
                                    <div className="container text-center" id="store-closed-message">
                                      <div className="image-container">
                                        <img
                                          src={`${image}${appname}/images/web/Store-Closed.svg`}
                                          alt="No spots available"
                                          className="img-fluid"
                                          style={{ maxWidth: "300px" }}
                                          id="store-closed-image"
                                        />
                                      </div>
                                      <h5 className="mt-3 fw-bold" style={{ color: '#dc3545' }} id="store-closed-title">Location Closed</h5>
                                      <p className="text-muted" id="store-closed-info">Add working hours to get started</p>
                                      <button
                                        className="stroke-button"
                                        id="add-store-button"
                                        onClick={handleAddWork}
                                        style={{ display: "inline-flex" }}
                                      >
                                        <span className="material-symbols-outlined">add</span>ADD WORKING HOURS
                                      </button>
                                    </div>
                                  )}
                              </>
                            ) : !loaderEnable && (
                              <div className="container text-center" id="no-spots-set">
                                <div className="image-container">
                                  <img
                                    src={`${image}${appname}/images/landingPage/spots-default-img.svg`}
                                    alt="No spots available"
                                    className="img-fluid"
                                    style={{ maxWidth: "300px" }}
                                    id="no-spots-image"
                                  />
                                </div>
                                <h5 className="mt-3 fw-bold" id="no-spots-title">No Spots Set Yet!</h5>
                                <p className="text-muted" id="no-spots-info">Add stores to get started</p>
                                <button
                                  className="stroke-button"
                                  id="add-store-button"
                                  onClick={handleAddWork}
                                  style={{ display: "inline-flex" }}
                                >
                                  <span className="material-symbols-outlined">add</span>ADD WORKING HOURS
                                </button>
                              </div>
                            )}

                          </div>


                          {/* SPECIAL HOURS TAB */}
                          <div className={`tab-pane ${isActive === "special" ? "active show" : ""}`} id="home1" role="tabpanel">
                            {SpecialSpotData?.length > 0 ? (
                              <div className={`tab-pane ${isActive === "special" ? "active show" : ""}`} id="home1" role="tabpanel">
                                <div className="row store" id="store-container">
                                  <div className="col-md-3" id="left-store-panel">
                                    {/* left side store panel */}
                                    <div className="store-panel-left" id="store-panel-left">
                                      <div className="d-flex align-items-center justify-content-between">
                                        <h4 className="form-title mb-0" id="location-info-title">LOCATION WORKING HOURS</h4>



                                        <button className="stroke-btn-style" onClick={handleAddSpot} id="add-spot-button">
                                          <span className="material-symbols-outlined">add</span>Add
                                        </button>
                                      </div>

                                      <div className="d-flex align-items-start">
                                        <div className="nav nav-pills special-hours-wrp-section mt-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                          {SpecialSpotData?.map((item) => {
                                            const data = item;
                                            return (
                                              <div
                                                className={item?.spotspecialfromdate === singleSplSpot?.spotspecialfromdate ? "nav-link special-hours-wrapper active" : "nav-link special-hours-wrapper"}
                                                data-bs-toggle="pill"
                                                data-bs-target="#special-hours-1"
                                                role="tab"
                                                aria-controls="special-hours-1"
                                                aria-selected="true"
                                                onClick={() => handleDateClick(item)}
                                                onKeyDown={keyActivate(() => handleDateClick(item))}
                                                id={`special-hours-item-${item?.spotspecialfromdate}`}
                                              >

                                                <div className="d-flex align-items-center special-hours-header mb-3">
                                                  <h4 className="form-title mb-0">


                                                    {/* {formatDate(item?.spotspecialfromdate)} */}
                                                    {formatDateUS(item?.spotspecialfromdate)}
                                                  </h4>
                                                  <div className="d-flex align-items-center gap-2">
                                                    <span className="material-symbols-outlined" onClick={(e) => { e.stopPropagation(); handleEditSpecial(item); }} onKeyDown={keyActivate((e) => { e.stopPropagation(); handleEditSpecial(item); })}>edit</span>
                                                    <span className="material-symbols-outlined" style={{ cursor: 'pointer', color: '#dc3545' }} onClick={(e) => { e.stopPropagation(); handleDeleteSpecialHour(item); }} onKeyDown={keyActivate((e) => { e.stopPropagation(); handleDeleteSpecialHour(item); })}>delete</span>
                                                  </div>
                                                </div>
                                                <div
                                                  className="input-field switch-buttons d-flex align-items-center"
                                                  style={{
                                                    gap: '10px',
                                                    minHeight: '34px'
                                                  }}
                                                >
                                                  <label
                                                    className="col-form-label p-0 me-2"
                                                    style={{
                                                      color: "#6C2BD9",
                                                      marginBottom: 0,
                                                      lineHeight: '1',
                                                      display: 'flex',
                                                      alignItems: 'center'
                                                    }}
                                                  >
                                                    <span style={{ color: item?.isopen ? '#198754' : '#dc3545', fontWeight: 700 }}>Location {item?.isopen ? 'Open' : 'Closed'}</span>
                                                  </label>

                                                  <label
                                                    className="switch disable mb-0"
                                                    style={{
                                                      display: 'flex',
                                                      alignItems: 'center'
                                                    }}
                                                  >

                                                    <Tooltip
                                                      title={item?.isopen ? "Click to close the store" : "Click to open the store"}
                                                    >
                                                      <input
                                                        type="checkbox"
                                                        id={`store-open-checkbox-${item?.storespotdayid}`}
                                                        checked={item?.isopen}
                                                        disabled={loaderEnable}
                                                        onChange={() =>
                                                          handleIsStoreOpen2(!item?.isopen, item?.storespotdayid)
                                                        }
                                                      />
                                                      <span className="slider round"></span>
                                                    </Tooltip>

                                                  </label>

                                                  {/* <small className="text-muted">Toggle to set the store as open or closed.</small> */}

                                                </div>

                                                <div style={!item?.isopen ? { opacity: 0.4, pointerEvents: 'none', userSelect: 'none' } : {}}>
                                                  {!item?.isopen && (
                                                    <div className="d-flex align-items-center gap-1 mt-3" style={{ color: '#dc3545', fontSize: '12px', fontWeight: 600 }}>
                                                      <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>block</span>
                                                      Location closed — hours inactive
                                                    </div>
                                                  )}
                                                  {item?.spotdaystartend?.map((item) => {
                                                    return (
                                                      <button className="time-fill-btn w-100 d-flex align-items-center justify-content-center" id={`time-slot-${item?.starttime}-${item?.endtime}`}>
                                                        <span className="material-symbols-outlined me-2 flex-shrink-0">schedule</span>
                                                        <span className="text-center">{`${formatTimeForDisplay(item?.starttime, item?.day)} to ${formatTimeForDisplay(item?.endtime, item?.endDay)}`}</span>
                                                      </button>
                                                    );
                                                  })}
                                                </div>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* right side store panel */}
                                  <div className="col-md-9 ps-1" id="right-store-panel">
                                    <div className="store-panel-right" id="store-panel-right">
                                      <div className="tab-content" id="v-pills-tabContent">
                                        <div className="store-panel-right">
                                          <div style={{ height: 500 }} className="calander-block" id="calendar-block">
                                            {singleSplSpot?.isopen === false ?
                                              <div className="container text-center" id="store-closed-message">
                                                <div className="image-container">
                                                  <img
                                                    src={`${image}${appname}/images/web/Store-Closed.svg`}
                                                    alt="No spots available"
                                                    className="img-fluid"
                                                    style={{ maxWidth: "300px" }}
                                                    id="store-closed-image"
                                                  />
                                                </div>
                                                <h5 className="mt-3 fw-bold" style={{ color: '#dc3545' }} id="store-closed-title">Location Closed</h5>
                                                <p className="text-muted" id="store-closed-info">Toggle the switch to open this location.</p>
                                              </div> :

                                              <>
                                                <h4 className="form-title mb-0" id="special-date-title">
                                                  <span>{formatDateUS(singleSplSpot?.spotspecialfromdate)}</span> PAID PLANS
                                                </h4>

                                                {uniqueDays.length > 0 ? (
                                                  uniqueDays.map(day => renderCalendarForDay(day))
                                                ) : (
                                                  <p>No slots available</p>
                                                )}
                                              </>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="container text-center" id="no-spots-container">
                                <div className="image-container" id="no-spots-image">
                                  <img
                                    src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/landingPage/spots-default-img.svg"
                                    alt="No spots available"
                                    className="img-fluid"
                                    style={{ maxWidth: "300px" }}
                                    id="no-spots-img"
                                  />
                                </div>
                                <h5 className="mt-3 fw-bold" id="no-spots-title">No Spots Set Yet!</h5>
                                <p className="text-muted" id="no-spots-text">Add stores to get started</p>
                                <button className="fill-btn-style" id="add-store-button" onClick={handleAddWork} style={{ display: "inline-flex" }}>
                                  <span className="material-symbols-outlined">add</span>ADD
                                </button>
                              </div>
                            )}
                          </div>


                        </div>
                        {/* spots tab Stop */}

                      </div>

                      <Modal className="add_hours" show={showPopup} size="xl">
                        <div className="modal-header">
                          <div className="add_hours_title">
                            <div className="modal-title h4">{singleDayData?.storespotdayid ? "EDIT" : "ADD"} HOURS</div>
                          </div>
                          <button type="button" className="close-btn"
                            // onClick={() => setShowModal(false)}
                            onClick={handleClose} id="spots-close-button">
                            <span className="material-icons">close</span>
                          </button>
                        </div>

                        <div className="modal-body p-0">
                          <div className="d-flex">
                          {/* Left: Working Hours */}
                          <div className="flex-grow-1 p-3" style={{ borderRight: '1px solid #e9ecef', minWidth: 0 }}>
                          <div
                            className="working_hours premium_hours"
                            style={workingHours?.length === 0 ? {
                              border: '2px solid #6200EA',
                              borderRadius: '8px',
                              padding: '8px 12px',
                              marginBottom: '10px',
                              background: '#f3eeff',
                              boxShadow: '0 0 0 3px rgba(98,0,234,0.08)'
                            } : {}}
                          >
                            <h6 style={workingHours?.length === 0 ? { color: '#6200EA', marginBottom: 0 } : {}}>
                              SET LOCATION WORKING HOURS
                              {workingHours?.length === 0 && (
                                <span style={{ fontSize: '11px', fontWeight: 400, color: '#6200EA', marginLeft: 8 }}>
                                  ← Start here
                                </span>
                              )}
                            </h6>
                          </div>

                          <div className="table-responsive">
                            <table className="table align-middle">
                              <thead>
                                <tr>
                                  <th width="30%">
                                    <div className="form-group">
                                      <label className="form_label" id="day-label">Select Day</label>
                                      <select
                                        className="form-select"
                                        value={selectedDay}
                                        onChange={(e) => {
                                          setSelectedDay(e.target.value);
                                          setSelectedStartTime('');
                                          setSelectedEndTime('');
                                          setSelectedDays([e.target.value])
                                        }}
                                        disabled={workingHours?.length > 0 || spotsData?.length > 0}
                                        id="select-day-label"
                                      >
                                        {daysOfWeek.map(day => (
                                          <option key={day} value={day}>{day}</option>
                                        ))}
                                      </select>
                                    </div>
                                  </th>
                                  <th width="30%">
                                    <div className="form-group">
                                      <label className="form_label" id="open-label">Opens</label>
                                      <select
                                        className="form-select"
                                        value={selectedStartTime}
                                        onChange={(e) => setSelectedStartTime(e.target.value)}
                                        id="spots-open-select"
                                      >
                                        <option value="">Select Open Time</option>
                                        {getStartTimeOptions().map(time => (
                                          <option key={time.value} value={time.value}>
                                            {time.displayValue}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </th>
                                  <th width="30%">
                                    <div className="form-group">
                                      <label className="form_label" id="close-label">Closes</label>
                                      <select
                                        key={endTimeKey}
                                        className="form-select"
                                        value={selectedEndTime}
                                        onChange={(e) => setSelectedEndTime(e.target.value)}
                                        disabled={!selectedStartTime}
                                        id="spots-close-select"
                                      >
                                        <option value="">Select Close Time</option>
                                        {getEndTimeOptions().map(time => (
                                          <option key={time.value} value={time.value}>
                                            {time.displayValue}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </th>
                                  <th width="10%" className="right" style={{ verticalAlign: 'bottom' }}>
                                    <div style={{ display: 'flex', gap: '6px', alignItems: 'center', justifyContent: 'flex-end' }}>
                                      <button
                                        className="fill-btn-style"
                                        id="save-button"
                                        onClick={handleAddWorkingHours}
                                      >
                                        <span className="material-symbols-outlined">
                                          {editMode ? 'edit' : 'add'}
                                        </span>
                                        {editMode ? 'update' : 'add'}
                                      </button>
                                      {editMode && (
                                        <button
                                          className="close-btn"
                                          title="Cancel edit"
                                          onClick={() => {
                                            const original = workingHours.find(h => h.id === editIndex);
                                            const changed = original && (
                                              selectedStartTime !== original.starttime ||
                                              selectedEndTime !== original.endtime
                                            );
                                            changed ? setShowDiscardEditConfirm('working') : handleCancelWorkingHoursEdit();
                                          }}
                                          style={{ position: 'static', padding: '2px 4px', background: 'none', border: 'none', color: '#6c757d', cursor: 'pointer', lineHeight: 1 }}
                                        >
                                          <span className="material-symbols-outlined" style={{ fontSize: '18px', verticalAlign: 'middle' }}>close</span>
                                        </button>
                                      )}
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>

                                {workingHours?.map((hour) => (
                                  <tr key={hour.id}>
                                    <td style={{ textAlign: 'center' }}>{hour.day}</td>
                                    <td>{formatTimeForDisplay(hour.starttime, hour.day)}</td>
                                    <td>{formatTimeForDisplay(hour.endtime, hour.endDay || hour.day, true, { day: hour.day, time: hour.starttime })}</td>
                                    <td className="right">
                                      <button className="btn btn-link p-0 me-2" onClick={() => handleEditWorkingHours(hour.id)} id="spots-edit-button">
                                        <span className="material-symbols-outlined">edit</span>
                                      </button>
                                      <button className="btn btn-link p-0" onClick={() => handleDeleteWorkingHours(hour.id)} id="spots-delete-button">
                                        <span className="material-symbols-outlined">delete</span>
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>

                          {/* {categoryTypes?.map((category, categoryIndex) => (
                            <div key={categoryIndex}>
                              <div className="working_hours premium_hours">

                                <h6
                                  style={{
                                    cursor: 'pointer',
                                    userSelect: 'none',
                                    color: categoryIndex === activeCategoryIndex ? '#6c63ff' : '#000',
                                    fontWeight: categoryIndex === activeCategoryIndex ? '600' : '500'
                                  }}
                                  onClick={() => handleCategoryClick(categoryIndex)}
                                >
                                  {category.name}
                                  {categoryIndex === activeCategoryIndex && ' (Active)'}
                                </h6>


                              </div>
                              <div className="table-responsive">
                                {categoryIndex !== activeCategoryIndex && (
                                  <div
                                    style={{
                                      padding: '10px 15px',
                                      backgroundColor: '#f8f9fa',
                                      border: '1px dashed #dee2e6',
                                      borderRadius: '4px',
                                      marginBottom: '10px',
                                      cursor: 'pointer',
                                      textAlign: 'center'
                                    }}
                                    onClick={() => handleCategoryClick(categoryIndex)}
                                  >
                                    <span style={{ color: '#6c757d', fontSize: '14px' }}>
                                      Click here or on “{category.name}” to enable editing and add hours.
                                    </span>
                                  </div>
                                )}

                                <table className="table align-middle">
                                  <thead onClick={() => handleCategoryFormClick(categoryIndex)}>
                                    <tr>
                                      <th width="28%">
                                        <div className="form-group">
                                          <label className="form_label" id="category-open-label">Opens</label>
                                          <select
                                            className="form-select"
                                            style={{ paddingRight: '2.5rem' }}
                                            value={categoryIndex === activeCategoryIndex ? selectedCategoryStartTime : ''}
                                            onChange={(e) => {
                                              handleCategoryInputChange(setSelectedCategoryStartTime, e.target.value);
                                              setSelectedCategoryEndTime('');
                                            }}
                                            disabled={categoryIndex !== activeCategoryIndex}
                                            id="spots-category-opens"
                                          >
                                            <option value="">Select Open Time</option>
                                            {categoryIndex === activeCategoryIndex && getCategoryStartTimeOptions().map(time => (
                                              <option key={time.value} value={time.value}>
                                                {time.displayValue}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </th>
                                      <th width="28%">
                                        <div className="form-group">
                                          <label className="form_label" id="category-close-label">Closes</label>
                                          <select
                                            key={categoryEndTimeKey}
                                            className="form-select"
                                            style={{ paddingRight: '2.5rem' }}
                                            value={categoryIndex === activeCategoryIndex ? selectedCategoryEndTime : ''}
                                            onChange={(e) => handleCategoryInputChange(setSelectedCategoryEndTime, e.target.value)}
                                            disabled={!selectedCategoryStartTime || categoryIndex !== activeCategoryIndex}
                                            id="spots-category-close"
                                          >
                                            <option value="">Select Close Time</option>
                                            {categoryIndex === activeCategoryIndex && selectedCategoryStartTime && getCategoryEndTimeOptions().map(time => (
                                              <option key={time.value} value={time.value}>
                                                {time.displayValue}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </th>
                                      <th width="17%">
                                        <div className="form-group">
                                          <label className="form_label" id="max-visitors-label">Visitors/Slot</label>
                                          <input
                                            className="form-control"
                                            placeholder="Enter"
                                            type="text"
                                            value={categoryIndex === activeCategoryIndex ? maxVisitors : ''}
                                            onChange={(e) => handleCategoryInputChange(setMaxVisitors, e.target.value)}
                                            disabled={categoryIndex !== activeCategoryIndex}
                                          />
                                        </div>
                                      </th>
                                      <th width="17%">
                                        <div className="form-group">
                                          <label className="form_label" id="price-label">Price / Spot</label>
                                          <input
                                            className="form-control"
                                            placeholder="00.00"
                                            type="text"
                                            value={categoryIndex === activeCategoryIndex ? pricePerSpot : ''}
                                            onChange={(e) => handleCategoryInputChange(setPricePerSpot, e.target.value)}
                                            disabled={categoryIndex !== activeCategoryIndex}
                                          />
                                        </div>
                                      </th>
                                      <th width="10%" className="right" style={{ display: 'flex', alignItems: 'flex-end', gap: '6px' }}>
                                        <button
                                          className="fill-btn-style"
                                          id="save-button"
                                          onClick={() => {
                                            if (categoryIndex !== activeCategoryIndex) {
                                              toast.error(`Please activate the ${category.name} plan first to add hours`, {
                                                position: "top-center",
                                                autoClose: 3000,
                                              });
                                            } else {
                                              handleAddCategoryHours();
                                            }
                                          }}
                                          disabled={categoryIndex !== activeCategoryIndex}
                                          style={{
                                            opacity: categoryIndex !== activeCategoryIndex ? 0.5 : 1,
                                            cursor: categoryIndex !== activeCategoryIndex ? 'not-allowed' : 'pointer',
                                          }}
                                        >
                                          {categoryIndex === activeCategoryIndex && <span className="material-symbols-outlined">
                                            {categoryEditMode && categoryIndex === activeCategoryIndex ? 'edit' : 'add'}
                                          </span>}
                                          {categoryEditMode && categoryIndex === activeCategoryIndex ? 'update' : 'add'}
                                        </button>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>

                                    {categoryHours?.filter(hour => hour.plan === category.plan)?.map((hour, idx) => (
                                      <tr key={`${hour.id}-${idx}`}>
                                        <td>{formatTimeForDisplay(hour.starttime, hour.day)}</td>
                                        <td>{formatTimeForDisplay(hour.endtime, hour.endDay || hour.day, true, { day: hour.day, time: hour.starttime })}</td>
                                        <td>{hour.maxvisitors}</td>
                                        <td>${hour.price}</td>
                                        <td className="right">
                                          <button className="btn btn-link p-0 me-2" onClick={() => handleEditCategoryHours(
                                            categoryHours.indexOf(hour)
                                          )}>
                                            <span className="material-symbols-outlined">edit</span>
                                          </button>
                                          <button className="btn btn-link p-0" onClick={() => {
                                            handleDeleteCategoryHours(
                                              categoryHours.indexOf(hour)
                                            ); setActiveCategoryIndex(categoryIndex);
                                          }}>
                                            <span className="material-symbols-outlined">delete</span>
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          ))} */}
                          {categoryTypes?.map((category, categoryIndex) => {
                            const isActive = categoryIndex === activeCategoryIndex;
                            const noWorkingHours = !workingHours?.length;

                            return (
                              <div
                                key={categoryIndex}
                                style={{
                                  backgroundColor: isActive ? '#ffffff' : '#f8f9fa',
                                  border: isActive ? '2px solid #6200EA' : '1px solid #e9ecef',
                                  borderRadius: '8px',
                                  marginBottom: '10px',
                                  transition: 'all 0.2s ease',
                                  boxShadow: isActive ? '0 4px 12px rgba(98, 0, 234, 0.08)' : 'none',
                                  overflow: 'hidden',
                                  opacity: noWorkingHours ? 0.45 : 1,
                                  pointerEvents: noWorkingHours ? 'none' : 'auto',
                                }}
                              >
                                {/* --- HEADER SECTION (Compact) --- */}
                                <div
                                  onClick={() => handleCategoryClick(categoryIndex)}
                                  onKeyDown={keyActivate(() => handleCategoryClick(categoryIndex))}
                                  style={{
                                    padding: '8px 15px', // Reduced padding
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    borderBottom: isActive ? '1px solid #f0f0f0' : 'none',
                                    backgroundColor: isActive ? '#fff' : 'transparent'
                                  }}
                                >
                                  {/* Compact Radio Button */}
                                  <div style={{
                                    height: '18px', // Smaller radio
                                    width: '18px',
                                    borderRadius: '50%',
                                    border: isActive ? '5px solid #6200EA' : '2px solid #ccc',
                                    backgroundColor: '#fff',
                                    flexShrink: 0,
                                    transition: 'all 0.2s ease'
                                  }}></div>

                                  <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
                                    <h6 style={{
                                      margin: 0,
                                      fontSize: '14px', // Smaller font
                                      fontWeight: isActive ? '700' : '600',
                                      color: isActive ? '#000' : '#6c757d'
                                    }}>
                                      {category.name}
                                    </h6>
                                    {isActive && categoryEditMode ? (
                                      <button
                                        className="close-btn"
                                        title="Cancel edit"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          const original = categoryHours[categoryEditIndex];
                                          const changed = original && (
                                            selectedCategoryStartTime !== original.starttime ||
                                            selectedCategoryEndTime !== original.endtime ||
                                            String(maxVisitors) !== String(original.maxvisitors) ||
                                            String(pricePerSpot) !== String(original.price)
                                          );
                                          changed ? setShowDiscardEditConfirm('category') : clearCategoryForm(categoryIndex);
                                        }}
                                        style={{ position: 'static', padding: '2px 4px', background: 'none', border: 'none', color: '#6c757d', cursor: 'pointer', lineHeight: 1, display: 'flex', alignItems: 'center' }}
                                      >
                                        <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>close</span>
                                      </button>
                                    ) : !isActive ? (
                                      <span style={{ fontSize: '11px', color: '#adb5bd', fontStyle: 'italic' }}>
                                        {categoryHours?.filter(h => h.plan === category.plan).length > 0
                                          ? `${categoryHours?.filter(h => h.plan === category.plan).length} slots configured`
                                          : 'Click to add hours'}
                                      </span>
                                    ) : null}
                                  </div>
                                </div>

                                {/* --- BODY SECTION --- */}
                                <div
                                  className="table-responsive"
                                  style={{
                                    // If inactive, we only show this section if there is data, otherwise it stays collapsed (Size of Old Version)
                                    display: !isActive && categoryHours?.filter(h => h.plan === category.plan).length === 0 ? 'none' : 'block',
                                    padding: '5px 15px 10px', // Tight padding
                                    opacity: isActive ? 1 : 0.5,
                                    pointerEvents: isActive ? 'auto' : 'none',
                                    transition: 'all 0.3s ease'
                                  }}
                                >
                                  <table className="table align-middle mb-0" style={{ fontSize: '13px' }}>
                                    {/* SMART HEADER: 
            Only show the INPUT inputs when Active. 
            If Inactive, we hide the inputs to save massive space (Old Version height).
          */}
                                    {isActive && (
                                      <thead>
                                        <tr>
                                          <th width="28%" className="p-1 border-0">
                                            <div className="form-group mb-0">
                                              <label className="form_label" style={{ fontSize: '10px', color: '#888', }}>Opens</label>
                                              <select
                                                className="form-select form-select-sm"
                                                style={{ fontSize: '12px', paddingTop: '2px', paddingBottom: '2px', paddingLeft: '8px' }}
                                                value={selectedCategoryStartTime}
                                                onChange={(e) => {
                                                  handleCategoryInputChange(setSelectedCategoryStartTime, e.target.value);
                                                  setSelectedCategoryEndTime('');
                                                }}
                                              >
                                                <option value="">Select Time</option>
                                                {getCategoryStartTimeOptions().map(time => (
                                                  <option key={time.value} value={time.value}>{time.displayValue}</option>
                                                ))}
                                              </select>
                                            </div>
                                          </th>
                                          <th width="28%" className="p-1 border-0">
                                            <div className="form-group mb-0">
                                              <label className="form_label" style={{ fontSize: '10px', color: '#888', }}>Closes</label>
                                              <select
                                                className="form-select form-select-sm"
                                                style={{ fontSize: '12px', paddingTop: '2px', paddingBottom: '2px', paddingLeft: '8px' }}
                                                value={selectedCategoryEndTime}
                                                onChange={(e) => handleCategoryInputChange(setSelectedCategoryEndTime, e.target.value)}
                                              >
                                                <option value="">Select Time</option>
                                                {selectedCategoryStartTime && getCategoryEndTimeOptions().map(time => (
                                                  <option key={time.value} value={time.value}>{time.displayValue}</option>
                                                ))}
                                              </select>
                                            </div>
                                          </th>
                                          <th width="17%" className="p-1 border-0">
                                            <div className="form-group mb-0">
                                              <label className="form_label" style={{ fontSize: '10px', color: '#888', }}>Visitors/Slot</label>
                                              <input
                                                className="form-control form-control-sm"
                                                style={{ fontSize: '12px', padding: '2px 8px' }}
                                                placeholder="0"
                                                type="text"
                                                value={maxVisitors}
                                                onChange={(e) => handleCategoryInputChange(setMaxVisitors, e.target.value)}
                                              />
                                            </div>
                                          </th>
                                          <th width="17%" className="p-1 border-0">
                                            <div className="form-group mb-0">
                                              <label className="form_label" style={{ fontSize: '10px', color: '#888', }}>Price</label>
                                              <input
                                                className="form-control form-control-sm"
                                                style={{ fontSize: '12px', padding: '2px 8px' }}
                                                placeholder="$"
                                                type="text"
                                                value={pricePerSpot}
                                                onChange={(e) => handleCategoryInputChange(setPricePerSpot, e.target.value)}
                                              />
                                            </div>
                                          </th>
                                          <th width="10%" className="p-1 border-0 text-end" style={{ verticalAlign: 'bottom' }}>
                                            <button
                                              className="fill-btn-style btn-sm"
                                              onClick={handleAddCategoryHours}
                                              style={{ padding: '0 10px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                                            >
                                              <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>
                                                {categoryEditMode ? 'edit' : 'add'}
                                              </span>
                                              {categoryEditMode ? 'update' : 'Add'}
                                            </button>
                                          </th>
                                        </tr>
                                      </thead>
                                    )}

                                    {/* SAVED DATA LIST */}
                                    <tbody>
                                      {/* If inactive and has data, add a small spacer or header row if needed, otherwise clean list */}
                                      {categoryHours?.filter(hour => hour.plan === category.plan)?.map((hour, idx) => (
                                        <tr key={`${hour.id}-${idx}`} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                          <td className="py-2 ps-1">{formatTimeForDisplay(hour.starttime, hour.day)}</td>
                                          <td className="py-2">{formatTimeForDisplay(hour.endtime, hour.endDay || hour.day, true, { day: hour.day, time: hour.starttime })}</td>
                                          <td className="py-2">{hour.maxvisitors} Visitors</td>
                                          <td className="py-2">${hour.price}</td>
                                          <td className="text-end py-2 pe-1">
                                            {/* Buttons visible but disabled via parent pointer-events if inactive */}
                                            <button className="btn btn-link p-0 me-2 text-secondary" style={{ textDecoration: 'none' }} onClick={() => handleEditCategoryHours(
                                              categoryHours.indexOf(hour)
                                            )}>
                                              <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>edit</span>
                                            </button>
                                            <button className="btn btn-link p-0 text-danger" style={{ textDecoration: 'none' }} onClick={() => {
                                              handleDeleteCategoryHours(
                                                categoryHours.indexOf(hour)
                                              ); setActiveCategoryIndex(categoryIndex);
                                            }}>
                                              <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>delete</span>
                                            </button>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            );
                          })}
                          </div>{/* end left working hours column */}

                          {/* Right: Plan Settings */}
                          <div style={{ width: 240, flexShrink: 0, padding: '16px', background: '#f8f9fa' }}>
                            <div className="working_hours premium_hours mb-2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                              <h6 style={{ margin: 0 }}>PLAN SETTINGS</h6>
                              {onEditPreferences && (
                                <button
                                  title="Edit plan settings"
                                  onClick={() => { setShowPoup(false); onEditPreferences(); }}
                                  style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px', color: '#5d1cd8', display: 'flex', alignItems: 'center' }}
                                >
                                  <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>edit</span>
                                </button>
                              )}
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 10 }}>
                              <div className="max_visitor_status" id="max-visitor-status" style={{ fontSize: 11 }}>
                                {`Max Visitors / Slot ${formData?.maxVisitor}`}
                              </div>
                              <div className="max_visitor_status" id="max-party-size" style={{ fontSize: 11 }}>
                                {`Max Party Size / Slot ${formData?.maxPartySize}`}
                              </div>
                            </div>
                            {categoryTypes?.length > 0 ? categoryTypes.map((plan) => (
                              <div key={plan.plan} style={{ marginBottom: 10, padding: '10px 12px', background: '#fff', borderRadius: 8, border: '1px solid #e9ecef' }}>
                                <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 8, color: '#5d1cd8' }}>{plan.name}</div>
                                {/* Percentage row */}
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 5 }}>
                                  <span style={{ fontSize: 11, color: '#888' }}>Percentage</span>
                                  <span style={{ fontSize: 12, fontWeight: 600, color: '#333' }}>{plan?.percentage}%</span>
                                </div>
                                {/* Max Visitors row */}
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 5 }}>
                                  <span style={{ fontSize: 11, color: '#888' }}>Max Visitors / Slot</span>
                                  <span style={{
                                    background: '#ede9fe', color: '#6d28d9',
                                    fontSize: 12, fontWeight: 700,
                                    padding: '2px 9px', borderRadius: 20,
                                    minWidth: 28, textAlign: 'center'
                                  }}>
                                    {plan.maxvisitors}
                                  </span>
                                </div>
                                {/* Price row */}
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                  <span style={{ fontSize: 11, color: '#888' }}>Price</span>
                                  <span style={{ fontSize: 12, fontWeight: 600, color: '#333' }}>${plan.price}</span>
                                </div>
                              </div>
                            )) : (
                              <p style={{ fontSize: 12, color: '#aaa' }}>No active plans configured.</p>
                            )}
                          </div>
                          </div>{/* end d-flex */}

                          <div className="modal-footer">
                            <div className="following_days" id="following-days-section">

                              <p>Apply the above settings to the following days</p>
                              <div className="check_buttons" id="days-check-buttons">
                                {daysOfWeek
                                  .filter((day) => day !== selectedDay)
                                  .map((day) => (
                                    <div
                                      key={day}
                                      className={`check_button ${selectedDays.includes(day) ? "active" : ""}`}
                                      onClick={() => handleDaySelect(day)}
                                      onKeyDown={keyActivate(() => handleDaySelect(day))}
                                      id={`day-select-${day}`}
                                    >
                                      {day.slice(0, 3).toUpperCase()}
                                    </div>
                                  ))}
                              </div>

                            </div>

                            {singleDayData?.storespotdayid ? <button disabled={loaderEnable} className="fill-btn-style" id="save-footer-button" onClick={handleCalender}>   {loaderEnable ? (
                              <img
                                src={"https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"}
                                className="loading-icon"
                              />
                            ) : null}Update</button> : <button className="fill-btn-style" id="save-footer-button" disabled={loaderEnable} onClick={handleCalender}>   {loaderEnable ? (
                              <img
                                src={"https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"}
                                className="loading-icon"
                              />
                            ) : null}Add</button>}

                          </div>
                        </div>


                      </Modal>

                      <Modal
                        className="access-denied"
                        show={showCategoryDiscardPopup}
                        centered
                      >
                        <div className="modal-body enquiry-form">
                          <div className="container">
                            <button
                              className="close-btn"
                              onClick={handleContinueEditing}
                            >
                              <span className="material-icons">close</span>
                            </button>

                            <span className="material-symbols-outlined access-denied-icon">
                              warning
                            </span>

                            <h3>Unsaved Changes</h3>

                            <p>
                              You have unsaved changes in {categoryTypes[activeCategoryIndex]?.name}.<br />
                              Do you want to discard them or continue editing?
                            </p>

                            <div className="popup-footer d-flex gap-2">
                              <button
                                className="fill_btn"
                                onClick={handleDiscardAndSwitch}
                              >
                                Discard
                              </button>

                              <button
                                className="fill_btn yellow-gradient"
                                onClick={handleContinueEditing}
                              >
                                Continue Editing
                              </button>
                            </div>
                          </div>
                        </div>
                      </Modal>


                      <Modal
                        className="access-denied"
                        show={showCloseConfirmPopup}
                        centered
                      >
                        <div className="modal-body enquiry-form">
                          <div className="container">
                            <button
                              className="close-btn"
                              onClick={() => setShowCloseConfirmPopup(false)}
                            >
                              <span className="material-icons">close</span>
                            </button>

                            <span className="material-symbols-outlined access-denied-icon">
                              warning
                            </span>

                            <h3>Unsaved Changes</h3>

                            <p>
                              You have unsaved changes.<br />
                              Do you want to discard them or update and save?
                            </p>

                            <div className="popup-footer d-flex gap-2">
                              <button
                                className="fill_btn"
                                onClick={closeAndReset}
                              >
                                Discard
                              </button>

                              <button
                                className="fill_btn yellow-gradient"
                                onClick={() => { setShowCloseConfirmPopup(false); handleCalender(); }}
                              >
                                Update & Save
                              </button>
                            </div>
                          </div>
                        </div>
                      </Modal>


                      <Modal className="access-denied" show={!!showDiscardEditConfirm} centered>
                        <div className="modal-body enquiry-form">
                          <div className="container">
                            <button className="close-btn" onClick={() => setShowDiscardEditConfirm(null)}>
                              <span className="material-icons">close</span>
                            </button>
                            <span className="material-symbols-outlined access-denied-icon">warning</span>
                            <h3>Discard Changes?</h3>
                            <p>You have unsaved changes. Are you sure you want to discard them?</p>
                            <div className="popup-footer d-flex gap-2">
                              <button
                                className="fill_btn"
                                onClick={() => {
                                  if (showDiscardEditConfirm === 'working') handleCancelWorkingHoursEdit();
                                  else clearCategoryForm(activeCategoryIndex);
                                  setShowDiscardEditConfirm(null);
                                }}
                              >
                                Discard
                              </button>
                              <button
                                className="fill_btn yellow-gradient"
                                onClick={() => setShowDiscardEditConfirm(null)}
                              >
                                Keep Editing
                              </button>
                            </div>
                          </div>
                        </div>
                      </Modal>

                      <Modal className="add_hours special-hours-popup" show={showSpecialHours} id="special-hours-modal">
                        <div className="modal-header">
                          <div className="add_hours_title">
                            <div className="modal-title h4" id="modal-title">{singleSplData?.storespotdayid ? 'EDIT' : 'ADD'} SPECIAL HOURS</div>
                          </div>
                          <button type="button" className="close-btn" id="close-button">
                            <span className="material-icons" onClick={handleClose} onKeyDown={keyActivate(handleClose)}>close</span>
                          </button>
                        </div>

                        <div className="modal-body special-hours" id="modal-body">
                          <div className="special-hours-left" id="special-hours-left">
                            <div className="d-flex align-items-center justify-content-between mx-3 mt-3 mb-3">
                              <h5 className="fw-bold m-0" id="selected-date-label">Selected Date</h5>
                              <div className="input-field switch-buttons d-flex align-items-center">
                                <label className="col-form-label p-0 me-2 m-0 fw-semibold" style={{ fontSize: '14px' }}>
                                  <span style={{ color: (singleSplData?.storespotdayid ? singleSplSpot?.isopen : isStoreOpen) ? '#198754' : '#dc3545', fontWeight: 700 }}>
                                    Location {singleSplData?.storespotdayid ? (singleSplSpot?.isopen ? 'Open' : 'Closed') : (isStoreOpen ? 'Open' : 'Closed')}
                                  </span>
                                </label>
                                <label className="switch disable mb-0">
                                  <Tooltip title={singleSplData?.storespotdayid
                                    ? (singleSplSpot?.isopen ? "Click to close the location" : "Click to open the location")
                                    : (isStoreOpen ? "Location will be open" : "Location will be closed")
                                  }>
                                    <input
                                      type="checkbox"
                                      id={singleSplData?.storespotdayid ? `store-open-checkbox-${singleSplSpot?.storespotdayid}` : 'store-open-checkbox-new'}
                                      checked={singleSplData?.storespotdayid ? singleSplSpot?.isopen : isStoreOpen}
                                      disabled={loaderEnable || (singleSplData?.storespotdayid && loaderEnable)}
                                      onChange={() => {
                                        if (singleSplData?.storespotdayid) {
                                          // Edit mode - call API immediately
                                          handleIsStoreOpen2(!singleSplSpot?.isopen, singleSplSpot?.storespotdayid, true);
                                        } else {
                                          // Add mode - just toggle state
                                          setIsStoreOpen(!isStoreOpen);
                                        }
                                      }}
                                    />
                                    <span className="slider round"></span>
                                  </Tooltip>
                                </label>
                              </div>
                            </div>
                            {/* <div className="d-flex align-items-center justify-content-between mx-3 mt-3 mb-3">
                              <h5 className="fw-bold m-0" id="selected-date-label">Selected Date</h5>
                              {singleSplData?.storespotdayid &&
                                <div className="input-field switch-buttons d-flex align-items-center">
                                  <label className="col-form-label p-0 me-2 m-0 fw-semibold" style={{ fontSize: '14px' }}>
                                    Store {singleSplSpot?.isopen ? 'Open' : 'Closed'}
                                  </label>
                                  <label className="switch disable mb-0">
                                    <Tooltip title={singleSplSpot?.isopen ? "Click to close the store" : "Click to open the store"}>
                                      <input
                                        type="checkbox"
                                        id={`store-open-checkbox-${singleSplSpot?.storespotdayid}`}
                                        checked={singleSplSpot?.isopen}
                                        disabled={loaderEnable}
                                        onChange={() => handleIsStoreOpen2(!singleSplSpot?.isopen, singleSplSpot?.storespotdayid, true)}
                                      />
                                      <span className="slider round"></span>
                                    </Tooltip>
                                  </label>
                                </div>}
                            </div> */}

                            <div className="calendar-wrapper px-3" id="calendar-wrapper">
                              <Calendar
                                tileDisabled={disablePastDates}
                                onChange={handleDateChange}
                                id="calendar-component"
                              />
                            </div>
                          </div>
                          <div
                            className="special-hours-right"
                            id="special-hours-right"
                          >
                            {selectedDate?.length > 0 ? (
                              <>
                                <div
                                  style={
                                    (singleSplData?.storespotdayid ? !singleSplSpot?.isopen : !isStoreOpen)
                                      ? { pointerEvents: 'none', opacity: 0.4, userSelect: 'none' }
                                      : {}
                                  }
                                >
                                <div className="working_hours premium_hours" id="working-hours">
                                  <h6>SET STORE WORKING HOURS</h6>
                                </div>

                                <div className="table-responsive">
                                  <table className="table align-middle">
                                    <thead>
                                      <tr>
                                        <th width="30%">
                                          <div className="form-group">
                                            <label className="form_label" id="open-label">Opens</label>
                                            <select
                                              className="form-select"
                                              value={selectedStartTime}
                                              onChange={(e) => setSelectedStartTime(e.target.value)}
                                              id="spots-open-select"
                                            >
                                              <option value="">Select Open Time</option>
                                              {getStartTimeOptions().map(time => (
                                                <option key={time.value} value={time.value}>
                                                  {time.displayValue}
                                                </option>
                                              ))}
                                            </select>
                                          </div>
                                        </th>
                                        <th width="30%">
                                          <div className="form-group">
                                            <label className="form_label" id="close-label">Closes</label>
                                            <select
                                              key={endTimeKey}
                                              className="form-select"
                                              value={selectedEndTime}
                                              onChange={(e) => setSelectedEndTime(e.target.value)}
                                              disabled={!selectedStartTime}
                                              id="spots-close-select"
                                            >
                                              <option value="">Select Close Time</option>
                                              {getEndTimeOptions().map(time => (
                                                <option key={time.value} value={time.value}>
                                                  {time.displayValue}
                                                </option>
                                              ))}
                                            </select>
                                          </div>
                                        </th>
                                        <th width="10%" className="right">
                                          <button
                                            className="fill-btn-style"
                                            id="save-button"
                                            onClick={handleAddWorkingHours}
                                          // disabled={!selectedStartTime || !selectedEndTime}
                                          >
                                            <span className="material-symbols-outlined">
                                              {editMode ? 'edit' : 'add'}
                                            </span>
                                            {editMode ? 'update' : 'add'}
                                          </button>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>

                                      {workingHours.map((hour) => (
                                        <tr key={hour.id}>
                                          {/* <td>{hour.day}</td> */}
                                          <td>{formatTimeForDisplay(hour.starttime, hour.day)}</td>
                                          <td>{formatTimeForDisplay(hour.endtime, hour.endDay || hour.day, true, { day: hour.day, time: hour.starttime })}</td>
                                          <td className="right">
                                            <button className="btn btn-link p-0 me-2" onClick={() => handleEditWorkingHours(hour.id)} id="spots-edit-button">
                                              <span className="material-symbols-outlined">edit</span>
                                            </button>
                                            <button className="btn btn-link p-0" onClick={() => handleDeleteWorkingHours(hour.id)} id="spots-delete-button">
                                              <span className="material-symbols-outlined">delete</span>
                                            </button>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>

                                {categoryTypes?.map((category, categoryIndex) => {
                                  const isActive = categoryIndex === activeCategoryIndex;

                                  return (
                                    <div
                                      key={categoryIndex}
                                      style={{
                                        backgroundColor: isActive ? '#ffffff' : '#f8f9fa',
                                        border: isActive ? '2px solid #6200EA' : '1px solid #e9ecef',
                                        borderRadius: '8px', // Smaller radius
                                        marginBottom: '10px', // Reduced margin between cards
                                        transition: 'all 0.2s ease',
                                        boxShadow: isActive ? '0 4px 12px rgba(98, 0, 234, 0.08)' : 'none',
                                        overflow: 'hidden'
                                      }}
                                    >
                                      {/* --- HEADER SECTION (Compact) --- */}
                                      <div
                                        onClick={() => handleCategoryClick(categoryIndex)}
                                        onKeyDown={keyActivate(() => handleCategoryClick(categoryIndex))}
                                        style={{
                                          padding: '8px 15px', // Reduced padding
                                          cursor: 'pointer',
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '10px',
                                          borderBottom: isActive ? '1px solid #f0f0f0' : 'none',
                                          backgroundColor: isActive ? '#fff' : 'transparent'
                                        }}
                                      >
                                        {/* Compact Radio Button */}
                                        <div style={{
                                          height: '18px', // Smaller radio
                                          width: '18px',
                                          borderRadius: '50%',
                                          border: isActive ? '5px solid #6200EA' : '2px solid #ccc',
                                          backgroundColor: '#fff',
                                          flexShrink: 0,
                                          transition: 'all 0.2s ease'
                                        }}></div>

                                        <div style={{ display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'space-between' }}>
                                          <h6 style={{
                                            margin: 0,
                                            fontSize: '14px', // Smaller font
                                            fontWeight: isActive ? '700' : '600',
                                            color: isActive ? '#000' : '#6c757d'
                                          }}>
                                            {category.name}
                                          </h6>
                                          {!isActive && (
                                            <span style={{ fontSize: '11px', color: '#adb5bd', fontStyle: 'italic' }}>
                                              {categoryHours?.filter(h => h.plan === category.plan).length > 0
                                                ? `${categoryHours?.filter(h => h.plan === category.plan).length} slots configured`
                                                : 'Click to add hours'}
                                            </span>
                                          )}
                                        </div>
                                      </div>

                                      {/* --- BODY SECTION --- */}
                                      <div
                                        className="table-responsive"
                                        style={{
                                          // If inactive, we only show this section if there is data, otherwise it stays collapsed (Size of Old Version)
                                          display: !isActive && categoryHours?.filter(h => h.plan === category.plan).length === 0 ? 'none' : 'block',
                                          padding: '5px 15px 10px', // Tight padding
                                          opacity: isActive ? 1 : 0.5,
                                          pointerEvents: isActive ? 'auto' : 'none',
                                          transition: 'all 0.3s ease'
                                        }}
                                      >
                                        <table className="table align-middle mb-0" style={{ fontSize: '13px' }}>
                                          {/* SMART HEADER: 
            Only show the INPUT inputs when Active. 
            If Inactive, we hide the inputs to save massive space (Old Version height).
          */}
                                          {isActive && (
                                            <thead>
                                              <tr>
                                                <th width="28%" className="p-1 border-0">
                                                  <div className="form-group mb-0">
                                                    <label className="form_label" style={{ fontSize: '10px', color: '#888', }}>Opens</label>
                                                    <select
                                                      className="form-select form-select-sm"
                                                      style={{ fontSize: '12px', paddingTop: '2px', paddingBottom: '2px', paddingLeft: '8px' }}
                                                      value={selectedCategoryStartTime}
                                                      onChange={(e) => {
                                                        handleCategoryInputChange(setSelectedCategoryStartTime, e.target.value);
                                                        setSelectedCategoryEndTime('');
                                                      }}
                                                    >
                                                      <option value="">Select Time</option>
                                                      {getCategoryStartTimeOptions().map(time => (
                                                        <option key={time.value} value={time.value}>{time.displayValue}</option>
                                                      ))}
                                                    </select>
                                                  </div>
                                                </th>
                                                <th width="28%" className="p-1 border-0">
                                                  <div className="form-group mb-0">
                                                    <label className="form_label" style={{ fontSize: '10px', color: '#888', }}>Closes</label>
                                                    <select
                                                      className="form-select form-select-sm"
                                                      style={{ fontSize: '12px', paddingTop: '2px', paddingBottom: '2px', paddingLeft: '8px' }}
                                                      value={selectedCategoryEndTime}
                                                      onChange={(e) => handleCategoryInputChange(setSelectedCategoryEndTime, e.target.value)}
                                                    >
                                                      <option value="">Select Time</option>
                                                      {selectedCategoryStartTime && getCategoryEndTimeOptions().map(time => (
                                                        <option key={time.value} value={time.value}>{time.displayValue}</option>
                                                      ))}
                                                    </select>
                                                  </div>
                                                </th>
                                                <th width="17%" className="p-1 border-0">
                                                  <div className="form-group mb-0">
                                                    <label className="form_label" style={{ fontSize: '10px', color: '#888', }}>Visitors/Slot</label>
                                                    <input
                                                      className="form-control form-control-sm"
                                                      style={{ fontSize: '12px', padding: '2px 8px' }}
                                                      placeholder="0"
                                                      type="text"
                                                      value={maxVisitors}
                                                      onChange={(e) => handleCategoryInputChange(setMaxVisitors, e.target.value)}
                                                    />
                                                  </div>
                                                </th>
                                                <th width="17%" className="p-1 border-0">
                                                  <div className="form-group mb-0">
                                                    <label className="form_label" style={{ fontSize: '10px', color: '#888', }}>Price</label>
                                                    <input
                                                      className="form-control form-control-sm"
                                                      style={{ fontSize: '12px', padding: '2px 8px' }}
                                                      placeholder="$"
                                                      type="text"
                                                      value={pricePerSpot}
                                                      onChange={(e) => handleCategoryInputChange(setPricePerSpot, e.target.value)}
                                                    />
                                                  </div>
                                                </th>
                                                <th width="10%" className="p-1 border-0 text-end" style={{ verticalAlign: 'bottom' }}>
                                                  <button
                                                    className="fill-btn-style btn-sm"
                                                    onClick={handleAddCategoryHours}
                                                    style={{ padding: '0 10px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
                                                  >
                                                    <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>
                                                      {categoryEditMode ? 'edit' : 'add'}
                                                    </span>
                                                    {categoryEditMode ? 'update' : 'Add'}
                                                  </button>
                                                </th>
                                              </tr>
                                            </thead>
                                          )}

                                          {/* SAVED DATA LIST */}
                                          <tbody>
                                            {/* If inactive and has data, add a small spacer or header row if needed, otherwise clean list */}
                                            {categoryHours?.filter(hour => hour.plan === category.plan)?.map((hour, idx) => (
                                              <tr key={`${hour.id}-${idx}`} style={{ borderBottom: '1px solid #f0f0f0' }}>
                                                <td className="py-2 ps-1">{formatTimeForDisplay(hour.starttime, hour.day)}</td>
                                                <td className="py-2">{formatTimeForDisplay(hour.endtime, hour.endDay || hour.day, true, { day: hour.day, time: hour.starttime })}</td>
                                                <td className="py-2">{hour.maxvisitors} Visitors</td>
                                                <td className="py-2">${hour.price}</td>
                                                <td className="text-end py-2 pe-1">
                                                  {/* Buttons visible but disabled via parent pointer-events if inactive */}
                                                  <button className="btn btn-link p-0 me-2 text-secondary" style={{ textDecoration: 'none' }} onClick={() => handleEditCategoryHours(
                                                    categoryHours.indexOf(hour)
                                                  )}>
                                                    <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>edit</span>
                                                  </button>
                                                  <button className="btn btn-link p-0 text-danger" style={{ textDecoration: 'none' }} onClick={() => {
                                                    handleDeleteCategoryHours(
                                                      categoryHours.indexOf(hour)
                                                    ); setActiveCategoryIndex(categoryIndex);
                                                  }}>
                                                    <span className="material-symbols-outlined" style={{ fontSize: '16px' }}>delete</span>
                                                  </button>
                                                </td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  );
                                })}
                                </div>

                                <div className="mx-2">
                                  {singleSplData?.storespotdayid ? <button className="fill-btn-style mt-3 mb-3" disabled={loaderEnable} onClick={handleCalender} id="update-calendar-button">
                                    {loaderEnable && !isModal ? (
                                      <img
                                        src={"https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"}
                                        className="loading-icon"
                                      />
                                    ) : null}UPDATE</button> : <button className="fill-btn-style mt-3 mb-3" disabled={loaderEnable} onClick={handleCalender} id="add-calendar-button">
                                    {loaderEnable ? (
                                      <img
                                        src={"https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"}
                                        className="loading-icon"
                                      />
                                    ) : null}ADD</button>}

                                </div>
                              </>
                            ) : (
                              <div className="container text-center" id="no-spots-container">
                                <div className="image-container" style={{ marginTop: "60px" }}>
                                  <img
                                    src={`${image}${appname}/images/landingPage/spots-default-img.svg`}
                                    alt="No spots available"
                                    className="img-fluid"
                                    style={{ maxWidth: "300px" }}
                                    id="no-spots-image"
                                  />
                                </div>
                                <h5 className="mt-3 fw-bold" id="no-spots-message">Select Date And Continue</h5>
                                <p className="text-muted" id="no-spots-instruction">Click 'Add' To Set</p>
                              </div>
                            )}
                          </div>

                          {/* Right: Plan Settings */}
                          <div style={{ width: 220, flexShrink: 0, padding: '16px', background: '#f8f9fa', borderLeft: '1px solid #e9ecef', overflowY: 'auto' }}>
                            <div className="working_hours premium_hours mb-2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                              <h6 style={{ margin: 0 }}>PLAN SETTINGS</h6>
                              {onEditPreferences && (
                                <button
                                  title="Edit plan settings"
                                  onClick={() => { closeAndReset(); onEditPreferences(); }}
                                  style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '2px 4px', color: '#5d1cd8', display: 'flex', alignItems: 'center' }}
                                >
                                  <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>edit</span>
                                </button>
                              )}
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 10 }}>
                              <div className="max_visitor_status" style={{ fontSize: 11 }}>
                                {`Max Visitors / Slot ${formData?.maxVisitor}`}
                              </div>
                              <div className="max_visitor_status" style={{ fontSize: 11 }}>
                                {`Max Party Size / Slot ${formData?.maxPartySize}`}
                              </div>
                            </div>
                            {categoryTypes?.length > 0 ? categoryTypes.map((plan) => (
                              <div key={plan.plan} style={{ marginBottom: 10, padding: '10px 12px', background: '#fff', borderRadius: 8, border: '1px solid #e9ecef' }}>
                                <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 8, color: '#5d1cd8' }}>{plan.name}</div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 5 }}>
                                  <span style={{ fontSize: 11, color: '#888' }}>Percentage</span>
                                  <span style={{ fontSize: 12, fontWeight: 600, color: '#333' }}>{plan?.percentage}%</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 5 }}>
                                  <span style={{ fontSize: 11, color: '#888' }}>Max Visitors / Slot</span>
                                  <span style={{ background: '#ede9fe', color: '#6d28d9', fontSize: 12, fontWeight: 700, padding: '2px 9px', borderRadius: 20, minWidth: 28, textAlign: 'center' }}>
                                    {plan.maxvisitors}
                                  </span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                  <span style={{ fontSize: 11, color: '#888' }}>Price</span>
                                  <span style={{ fontSize: 12, fontWeight: 600, color: '#333' }}>${plan.price}</span>
                                </div>
                              </div>
                            )) : (
                              <p style={{ fontSize: 12, color: '#aaa' }}>No active plans configured.</p>
                            )}
                          </div>

                        </div>
                      </Modal>

                      {/* Missing Plans Warning Modal */}
                      {/* Missing Plans Warning Modal */}
                      {/* <Modal className="access-denied" show={showPlanWarningModal} centered>
                        <div className="modal-body enquiry-form">
                          <div className="container">
                            <button className="close-btn" onClick={() => setShowPlanWarningModal(false)}>
                              <span className="material-icons">close</span>
                            </button>

                            <span className="material-symbols-outlined access-denied-icon">
                              warning
                            </span>

                            <h3>Warning</h3>
                            <p>
                              Are you sure you want to continue without adding{" "}
                              {missingPlans.length === 1
                                ? `${missingPlans[0]} plan`
                                : missingPlans.length === 2
                                  ? `${missingPlans[0]} and ${missingPlans[1]} plans`
                                  : `${missingPlans.slice(0, -1).join(", ")}, and ${missingPlans[missingPlans.length - 1]} plans`
                              }?
                            </p>

                            <div className="popup-footer d-flex gap-2">
                              <button
                                className="fill_btn"
                                type="button"
                                onClick={() => setShowPlanWarningModal(false)}
                              >
                                Cancel
                              </button>

                              <button
                                disabled={loaderEnable}
                                className="fill_btn yellow-gradient"
                                type="button"
                                onClick={() => proceedWithCalender()}
                              >
                                {loaderEnable ? (
                                  <img
                                    src={`${image}${appname}/images/web/rotate_right.svg`}
                                    className="loading-icon"
                                    alt="Loading"
                                  />
                                ) : null}
                                Yes, Continue
                              </button>
                            </div>
                          </div>
                        </div>
                      </Modal> */}
                      <Modal className="access-denied" show={showPlanWarningModal} centered backdrop={false}>
                        <div className="modal-body enquiry-form">
                          <div className="container">
                            <button className="close-btn" onClick={() => setShowPlanWarningModal(false)}>
                              <span className="material-icons">close</span>
                            </button>

                            <span className="material-symbols-outlined access-denied-icon">
                              warning
                            </span>

                            <h3>Warning</h3>
                            <p>
                              This plan is listed as active under location preferences. If you continue without hours, this plan will not appear as a choice for your visitors. Are you sure you want to continue without adding{" "}
                              {missingPlans.length === 1 ? (
                                <strong>{missingPlans[0]?.toUpperCase()} PLAN HOURS</strong>
                              ) : missingPlans.length === 2 ? (
                                <>
                                  <strong>{missingPlans[0]?.toUpperCase()} PLAN HOURS</strong> and <strong>{missingPlans[1]?.toUpperCase()} PLAN HOURS</strong>
                                </>
                              ) : missingPlans.length > 2 ? (
                                <>
                                  {missingPlans.slice(0, -1).map((plan, index) => (
                                    <span key={index}>
                                      <strong>{plan?.toUpperCase()} PLAN HOURS</strong>
                                      {index < missingPlans.length - 2 ? ", " : ""}
                                    </span>
                                  ))}
                                  , and <strong>{missingPlans[missingPlans.length - 1]?.toUpperCase()} PLAN HOURS</strong>
                                </>
                              ) : null}?
                            </p>

                            <div className="popup-footer d-flex gap-2">
                              <button
                                className="fill_btn"
                                type="button"
                                onClick={() => setShowPlanWarningModal(false)}
                              >
                                Cancel
                              </button>

                              <button
                                disabled={loaderEnable}
                                className="fill_btn yellow-gradient"
                                type="button"
                                onClick={() => proceedWithCalender()}
                              >
                                {loaderEnable ? (
                                  <img
                                    src={`${image}${appname}/images/web/rotate_right.svg`}
                                    className="loading-icon"
                                    alt="Loading"
                                  />
                                ) : null}
                                Yes, Continue
                              </button>
                            </div>
                          </div>
                        </div>
                      </Modal>
                      {!embedded && (
                      <ToastContainer
                        id="toastContainer-spots"
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover={false}
                        theme="light"
                      />
                      )}
                      {/* <SweetAlert
                        success
                        show={showSuccessPopup}
                        title="Success"
                        onConfirm={() => setShowSuccessPopup(false)}
                      >
                        {successMessage}
                      </SweetAlert> */}
                      <SweetAlert
                        custom
                        show={showSuccessPopup}
                        confirmBtnText="ok"
                        confirmBtnStyle={{
                          backgroundColor: "#6C2BD9",   // violet
                          color: "#fff",
                          border: "none",
                          borderRadius: "6px",
                          padding: "8px 24px",
                          fontWeight: "600"
                        }}
                        title={successMessage}
                        onConfirm={() => setShowSuccessPopup(false)}
                      />
                      {/* Delete Working Hour Confirmation */}
                      {/* <SweetAlert
                        warning
                        show={showDeleteWorkingHourPopup}
                        showCancel
                        confirmBtnText="Yes, delete it!"
                        cancelBtnText="Cancel"
                        confirmBtnStyle={{
                          backgroundColor: "#6C2BD9",
                          color: "#fff",
                          border: "none",
                          borderRadius: "6px",
                          padding: "8px 24px",
                          fontWeight: "600"
                        }}

                        title="Are you sure?"
                        onConfirm={confirmDeleteWorkingHour}
                        onCancel={() => setShowDeleteWorkingHourPopup(false)}
                      >
                        You want to delete this working hour?
                      </SweetAlert>
 */}
                      <Modal className="access-denied" show={showDeleteWorkingHourPopup} centered>
                        <div className="modal-body enquiry-form">
                          <div className="container">
                            <button className="close-btn" onClick={() => setShowDeleteWorkingHourPopup(false)}>
                              <span className="material-icons">close</span>
                            </button>

                            <span className="material-symbols-outlined access-denied-icon">
                              warning
                            </span>

                            <h3>Are you sure?</h3>
                            <p>
                              Deleting these working hours will also remove all associated category hours (Basic, Premium, and VIP plans). This action cannot be undone. Are you sure you want to delete these working hours and all related category hours?
                            </p>

                            <div className="popup-footer d-flex gap-2">
                              <button
                                className="fill_btn"
                                type="button"
                                onClick={() => setShowDeleteWorkingHourPopup(false)}
                              >
                                Cancel
                              </button>

                              <button
                                className="fill_btn yellow-gradient"
                                type="button"
                                onClick={confirmDeleteWorkingHour}
                              >
                                Yes, delete it!
                              </button>
                            </div>
                          </div>
                        </div>
                      </Modal>

                      {/* <SweetAlert
        show={showDeleteAlert}
        title="Are you sure you want to delete this location?"
        showCancel
        confirmBtnText="OK"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="danger"
        onConfirm={handleDeleteClick}
        onCancel={() => setShowDeleteAlert(false)}
        id="delete-alert"
    /> */}

                      {/* Delete Special Hour Confirmation */}
                      <Modal className="access-denied" show={showDeleteSpecialHourPopup} centered>
                        <div className="modal-body enquiry-form">
                          <div className="container">
                            <button className="close-btn" onClick={() => setShowDeleteSpecialHourPopup(false)}>
                              <span className="material-icons">close</span>
                            </button>
                            <span className="material-symbols-outlined access-denied-icon">warning</span>
                            <h3>Are you sure?</h3>
                            <p>
                              Are you sure you want to delete the special hours for <strong>{formatDateUS(deleteSpecialHourItem?.spotspecialfromdate)}</strong>? This action cannot be undone.
                            </p>
                            <div className="popup-footer d-flex gap-2">
                              <button className="fill_btn" type="button" onClick={() => setShowDeleteSpecialHourPopup(false)}>
                                Cancel
                              </button>
                              <button className="fill_btn yellow-gradient" type="button" onClick={confirmDeleteSpecialHour} disabled={loaderEnable}>
                                Yes, delete it!
                              </button>
                            </div>
                          </div>
                        </div>
                      </Modal>

                      {/* Delete Category Hour Confirmation */}
                      {/* <SweetAlert
                        warning
                        show={showDeleteCategoryHourPopup}
                        showCancel
                        confirmBtnText="Yes, delete it!"
                        cancelBtnText="Cancel"
                        confirmBtnStyle={{
                          backgroundColor: "#6C2BD9",
                          color: "#fff",
                          border: "none",
                          borderRadius: "6px",
                          padding: "8px 24px",
                          fontWeight: "600"
                        }}

                        title="Are you sure?"
                        onConfirm={confirmDeleteCategoryHour}
                        onCancel={() => setShowDeleteCategoryHourPopup(false)}
                      >
                        You want to delete this category hour?
                      </SweetAlert> */}
                      <Modal className="access-denied" show={showDeleteCategoryHourPopup} centered>
                        <div className="modal-body enquiry-form">
                          <div className="container">
                            <button className="close-btn" onClick={() => setShowDeleteCategoryHourPopup(false)}>
                              <span className="material-icons">close</span>
                            </button>

                            <span className="material-symbols-outlined access-denied-icon">
                              warning
                            </span>

                            <h3>Are you sure?</h3>
                            <p>
                              This plan is listed as active under location preferences. If you delete these hours, this plan will not appear as a choice for your visitors. Are you sure you want to delete the hours for this active plan?
                            </p>

                            <div className="popup-footer d-flex gap-2">
                              <button
                                className="fill_btn"
                                type="button"
                                onClick={() => setShowDeleteCategoryHourPopup(false)}
                              >
                                Cancel
                              </button>

                              <button
                                className="fill_btn yellow-gradient"
                                type="button"
                                onClick={confirmDeleteCategoryHour}
                              >
                                Yes, delete it!
                              </button>
                            </div>
                          </div>
                        </div>
                      </Modal>
                    </div>
                  </div>
                </div>
            </PageWrapper>
          </div>
        }

      </LayoutWrapper>
    </>
  );
};

export default SpotsManageCore;
